(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[601],{

/***/ 7165:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
exports._getBeacons = exports.getApi = exports.setPageContext = exports.trackExitLink = exports.trackEventLater = exports.trackEvent = exports.trackPage = void 0;
var types_1 = __webpack_require__(5033);
function push(entry) {
    if (!window[types_1.WINDOW_KEY]) {
        window[types_1.WINDOW_KEY] = [];
    }
    return window[types_1.WINDOW_KEY].push(entry);
}
function getContextConfig(key, value) {
    var _a;
    if (typeof key === 'object') {
        return key;
    }
    return _a = {}, _a[key] = value, _a;
}
exports["default"] = {
    trackPage: trackPage,
    trackEvent: trackEvent,
    trackEventLater: trackEventLater,
    trackExitLink: trackExitLink,
    setPageContext: setPageContext,
    getApi: getApi
};
function trackPage(config) {
    return push([types_1.PAGE, config]);
}
exports.trackPage = trackPage;
function trackEvent(config) {
    return push([types_1.EVENT, config]);
}
exports.trackEvent = trackEvent;
function trackEventLater(config) {
    return push([types_1.EVENT_LATER, config]);
}
exports.trackEventLater = trackEventLater;
function trackExitLink(config) {
    return push([types_1.EXIT_LINK, config]);
}
exports.trackExitLink = trackExitLink;
function setPageContext(key, value) {
    return push([types_1.CONFIG, getContextConfig(key, value)]);
}
exports.setPageContext = setPageContext;
function getApi(callback) {
    return push([types_1.GET_API, callback]);
}
exports.getApi = getApi;
function _getBeacons() {
    return window[types_1.WINDOW_KEY];
}
exports._getBeacons = _getBeacons;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 5033:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

exports.__esModule = true;
exports.GET_API = exports.EXIT_LINK = exports.EVENT_LATER = exports.CONFIG = exports.PAGE = exports.EVENT = exports.WINDOW_KEY = void 0;
exports.WINDOW_KEY = '__analyticsQueue';
exports.EVENT = 'event';
exports.PAGE = 'page';
exports.CONFIG = 'config';
exports.EVENT_LATER = 'event-later';
exports.EXIT_LINK = 'exit-link';
exports.GET_API = 'get-api';
//# sourceMappingURL=types.js.map

/***/ }),

/***/ 5601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ createComponent; }
});

;// CONCATENATED MODULE: ../../node_modules/@finn-no/favorite-api-browser-client/dist/index.es.js
var STORAGE_KEY = '__lookupFavItem';
var STORAGE_VERSION = 4;
var MIN10 = 1000 * 60 * 10;
function mkItemFolder(itemType, itemId, folderIds) {
  return {
    itemType,
    itemId,
    folderIds
  };
}
function mkKey(itemType, itemId) {
  return "".concat(itemType, ":").concat(itemId);
} // this matches the data shape of the data we get from the servers minimal-v2-endpoint,

/*
{
    "items": [
        { "itemType": "Ad", "itemId": 456789, "folderIds": [ 1 ] },
        { "itemType": "Hotel", "itemId": 666, "folderIds": [ 1 ] },
        { "itemType": "Hotel", "itemId": 456789, "folderIds": [ 1 ] }
    ]
}
 */

class StorageAtom {
  constructor(ttl, version, userId, items, dataFromServer) {
    this.ttl = ttl;
    this.version = version;
    this.userId = userId;
    this.items = items;
    this.dataFromServer = dataFromServer;
  }

}

function replaceItems(state, newItems) {
  return new StorageAtom(state.ttl, state.version, state.userId, newItems, state.dataFromServer);
}

class FavoriteStorage {
  constructor(userId, onItemUpdate, storage, ttl, key, getNow) {
    this.userId = userId;
    this.storage = storage || window.localStorage;
    this.ttl = ttl || MIN10;
    this.key = key || STORAGE_KEY;

    this.getNow = getNow || (() => Date.now());

    this.key = STORAGE_KEY;

    this.storageHandler = event => {
      try {
        if (event.key !== this.key) {
          return;
        }

        if (event.oldValue === event.newValue) {
          return;
        }

        if (!event.newValue) {
          return;
        }

        var newValue = JSON.parse(event.newValue || '');

        if (newValue.userId.toString() !== this.userId.toString()) {
          return;
        }

        if (event.oldValue && newValue.items) {
          var oldValue = JSON.parse(event.oldValue);
          newValue.items.forEach(newKey => {
            var notPresentInOldValue = oldValue.items != null && !oldValue.items.find(i => i.itemType === newKey.itemType && i.itemId === newKey.itemId);

            if (notPresentInOldValue) {
              var newItemFolder = newValue.items.find(i => i.itemType === newKey.itemType && i.itemId === newKey.itemId) || mkItemFolder(newKey.itemType, newKey.itemId, []);
              onItemUpdate(mkKey(newKey.itemType, newKey.itemId), newItemFolder);
            }
          });
        } else {
          newValue.items.forEach(newKey => {
            var newItemFolder = newValue.items.find(i => i.itemType === newKey.itemType && i.itemId === newKey.itemId) || mkItemFolder(newKey.itemType, newKey.itemId, []);
            onItemUpdate(mkKey(newKey.itemType, newKey.itemId), newItemFolder);
          });
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log("unsuccessful handling of storage event: ".concat(e));
      }
    };

    window.addEventListener('storage', this.storageHandler);
  } // mainly used for storybook


  unbind() {
    window.removeEventListener('storage', this.storageHandler);
  }

  createEmptyState() {
    return new StorageAtom(this.getNow() + this.ttl, STORAGE_VERSION, this.userId.toString(), [], false);
  }

  resetState() {
    var newState = this.createEmptyState();
    this.storage.setItem(this.key, JSON.stringify(newState));
    return newState;
  }

  isValid(state) {
    if (!state || state.version !== STORAGE_VERSION || state.ttl <= this.getNow() || state.userId.toString() !== this.userId.toString()) {
      // Clearing potential old state (could be different user)
      return this.resetState();
    }

    return state;
  }

  getState() {
    try {
      var state = this.isValid(JSON.parse(this.storage.getItem(this.key) || ''));

      if (state) {
        return state;
      }
    } catch (e) {
      // invalid (unparsable) state: reset
      return this.resetState();
    }

    return this.createEmptyState();
  }

  isEmpty() {
    return !this.getState().dataFromServer;
  } // gets folderid[]


  getFolderIds(itemType, itemId) {
    var pred = i => i.itemType === itemType && i.itemId === itemId;

    var state = this.getState();

    if (state && state.items) {
      if (Array.isArray(state.items)) {
        var found = state.items.find(pred);

        if (found) {
          return found.folderIds;
        }
      } else {
        return [];
      }

      return [];
    }

    return [];
  } // used for manipulating local state


  addToFolder(itemType, itemId, folderId) {
    var entryExists = false;

    function mapper(item) {
      if (item.itemType === itemType && item.itemId === itemId) {
        entryExists = true; // we'll push the new entry onto a new item

        item.folderIds.push(folderId);
        return item;
      }

      return item;
    }

    try {
      var state = this.getState();

      if (state && state.items && state.items) {
        var newItems = state.items.map(mapper);
        state = replaceItems(state, newItems);
      }

      if (!entryExists) {
        state.items.push(mkItemFolder(itemType, itemId, [folderId]));
      }

      this.storage.setItem(this.key, JSON.stringify(state));
      return true;
    } catch (e) {
      return false;
    }
  } // used for manipulating local state


  removeFromFolder(itemType, itemId, folderId) {
    function filterFolder(item) {
      if (item.itemType === itemType && item.itemId === itemId) {
        var newFolders = item.folderIds.filter(aFolderId => aFolderId !== folderId);
        return mkItemFolder(item.itemType, item.itemId, newFolders);
      }

      return item;
    }

    try {
      var state = this.getState();

      if (state && state.items) {
        var newItems = state.items.map(filterFolder);
        state = replaceItems(state, newItems);
      }

      this.storage.setItem(this.key, JSON.stringify(state));
      return true;
    } catch (e) {
      return false;
    }
  } // used for manipulating local state


  removeFolder(folderId) {
    function removeFolder(item) {
      var newItems = item.folderIds.filter(aFolderId => aFolderId !== folderId);
      return mkItemFolder(item.itemType, item.itemId, newItems);
    }

    try {
      var state = this.getState();

      if (state && state.items) {
        var removed = state.items.map(removeFolder);
        var newItems = removed.filter(item => item.folderIds.length > 0);
        state = replaceItems(state, newItems);
      }

      this.storage.setItem(this.key, JSON.stringify(state));
      return true;
    } catch (e) {
      return false;
    }
  } // used to re-set state


  setItems(items) {
    try {
      var state = this.createEmptyState();
      state.items = items;
      state.dataFromServer = true;
      this.storage.setItem(this.key, JSON.stringify(state));
      return true;
    } catch (e) {
      return false;
    }
  }

}

class Fetcher {
  constructor(baseUri, fetch) {
    this.baseUri = baseUri;
    this.fetch = fetch || Fetcher.fetch;
    this.fetchFolders = this.fetchFolders.bind(this);
    this.fetchMinimalFavoriteMap = this.fetchMinimalFavoriteMap.bind(this);
    this.addToFolder = this.addToFolder.bind(this);
    this.removeFromFolder = this.removeFromFolder.bind(this);
    this.createFolder = this.createFolder.bind(this);
    this.deleteFolder = this.deleteFolder.bind(this);
    this.fetchNumFavs = this.fetchNumFavs.bind(this);
  } // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types


  static fetch(url, options) {
    return window.fetch(url, options);
  }

  static getCredentialsHeader() {
    var {
      host
    } = window.location;

    if (host.includes('local.finn.no')) {
      return 'include';
    }

    return 'same-origin';
  }

  fetchMinimalFavoriteMap() {
    return this.fetch("".concat(this.baseUri, "/v2/minimal"), {
      credentials: Fetcher.getCredentialsHeader()
    });
  }

  addToFolder(itemType, itemId, folderId) {
    return this.fetch("".concat(this.baseUri, "/").concat(folderId, "/").concat(itemType, "/").concat(itemId), {
      credentials: Fetcher.getCredentialsHeader(),
      method: 'PUT'
    });
  }

  removeFromFolder(itemType, itemId, folderId) {
    return this.fetch("".concat(this.baseUri, "/").concat(folderId, "/").concat(itemType, "/").concat(itemId), {
      credentials: Fetcher.getCredentialsHeader(),
      method: 'DELETE'
    });
  }

  fetchFolders() {
    return this.fetch(this.baseUri, {
      credentials: Fetcher.getCredentialsHeader()
    });
  }

  createFolder(name) {
    return this.fetch("".concat(this.baseUri), {
      credentials: Fetcher.getCredentialsHeader(),
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        name
      })
    });
  }

  deleteFolder(folderId) {
    return this.fetch("".concat(this.baseUri, "/").concat(folderId), {
      credentials: Fetcher.getCredentialsHeader(),
      method: 'DELETE'
    });
  }

  fetchNumFavs(itemType, itemId) {
    return this.fetch("".concat(this.baseUri, "/").concat(itemType, "/").concat(itemId, "/counter"), {
      credentials: Fetcher.getCredentialsHeader()
    });
  }

}

class ControllablePromise {
  constructor() {
    this.promise = new Promise((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }

}

class GlobalDelayedCollector {
  constructor(namespace, handler, timeout) {
    this.namespace = namespace;
    this.handler = handler;
    this.timeout = timeout || 15;
  }

  getGlobalPromise() {
    window[this.namespace] = window[this.namespace] || new ControllablePromise();
    return window[this.namespace];
  }

  resetState() {
    delete window[this.namespace];
  }

  collectAndHandle() {
    var state = this.getGlobalPromise();
    window.clearTimeout(state.timer);
    state.timer = window.setTimeout(() => {
      this.resetState();
      this.handler().then(state.resolve).catch(state.reject);
    }, this.timeout);
    return state.promise;
  }

}

class GlobalBus {
  constructor(ns) {
    this.key = "".concat(ns, "__queue");
    window[this.key] = window[this.key] || [];
  }

  reset() {
    window[this.key] = [];
  }

  getQueue() {
    return window[this.key];
  } // key is Ad:1234


  subscribe(key, func) {
    this.getQueue().push([key, func]);
  }

  unsubscribe(key, func) {
    window[this.key] = this.getQueue().filter((_ref) => {
      var [_key, _func] = _ref;
      return !(_key === key && _func === func);
    });
  } // key is Ad:1234


  matches(key) {
    return this.getQueue().filter((_ref2) => {
      var [_key, _] = _ref2;
      return _key.toString() === key.toString();
    }).map((_ref3) => {
      var [_key, func] = _ref3;
      return func;
    });
  } // key is Ad:1234


  emit(key, state) {
    this.matches(key).forEach(func => func(state));
  }

} // eslint-disable-next-line import/prefer-default-export


class FavoriteBrowserCache {
  constructor( // eslint-disable-next-line no-shadow
  userId, namespace, storage, ttl, fetch, baseUri) {
    this.namespace = namespace || '__lookupFavItem';
    this.toggledStateBus = new GlobalBus("".concat(this.namespace, "__toggled"));
    this.recountStateBus = new GlobalBus("".concat(this.namespace, "__recount"));
    this.favStorage = new FavoriteStorage(userId, (key, data) => {
      this.toggledStateBus.emit(key, !!data);
    }, storage, ttl);
    this.fetcher = new Fetcher(baseUri || FavoriteBrowserCache.getEnvBasedUrl(), fetch);
    this.getItemCollector = new GlobalDelayedCollector(this.namespace, () => this.fetcher.fetchMinimalFavoriteMap().then(FavoriteBrowserCache.validateResponseOK).then(res => res.json()).then(j => {
      this.favStorage.setItems(j.items);
      return j;
    }));
    this.fetchFolders = this.fetchFolders.bind(this);
    this.fetchFoldersForItem = this.fetchFoldersForItem.bind(this);
    this.addToFolder = this.addToFolder.bind(this);
    this.removeFromFolder = this.removeFromFolder.bind(this);
    this.createFolder = this.createFolder.bind(this);
    this.deleteFolder = this.deleteFolder.bind(this);
  }

  unmount() {
    this.toggledStateBus.reset();
    this.recountStateBus.reset();
    this.favStorage.unbind();
  }

  static getEnvBasedUrl() {
    var {
      host
    } = window.location;

    if (host.includes('local.finn.no')) {
      return 'http://local.finn.no:3050/favorittliste/podium-resource/favorittlistePodlet/favorite-api';
    }

    if (host.includes('dev.finn.no')) {
      return 'https://dev.finn.no/favorittliste/podium-resource/favorittlistePodlet/favorite-api';
    }

    return 'https://www.finn.no/favorittliste/podium-resource/favorittlistePodlet/favorite-api';
  }

  getFavoriteState(itemType, itemId, toggledFunc) {
    var itemIdNumber = Number(itemId);
    this.toggledStateBus.subscribe(mkKey(itemType, itemIdNumber), toggledFunc);
    this.isItemFavorited(itemType, itemIdNumber);
    return () => {
      this.toggledStateBus.unsubscribe(mkKey(itemType, itemIdNumber), toggledFunc);
    };
  }

  subscribeToRecount(itemType, itemId, recountFunc) {
    var itemIdNumber = Number(itemId);
    this.recountStateBus.subscribe(mkKey(itemType, itemIdNumber), recountFunc);
    this.fetchAndEmitNumFavs(itemType, itemIdNumber);
    return () => {
      this.recountStateBus.unsubscribe(mkKey(itemType, itemIdNumber), recountFunc);
    };
  }

  isItemFavorited(itemType, itemId) {
    var itemIdNumber = Number(itemId);

    if (this.favStorage.isEmpty()) {
      // This is the place that the storage gets filled up initially
      return this.getItemCollector.collectAndHandle().then(() => new Promise(resolve => {
        setTimeout(() => {
          var favs = this.favStorage.getFolderIds(itemType, itemIdNumber);
          this.toggledStateBus.emit(mkKey(itemType, itemIdNumber), favs.length > 0);

          if (favs.length > 0) {
            return resolve(true);
          }

          return resolve(false);
        }, 0);
      }));
    }

    var favs = this.favStorage.getFolderIds(itemType, itemIdNumber); // getFromId(id);

    this.toggledStateBus.emit(mkKey(itemType, itemIdNumber), favs.length > 0);

    if (favs.length > 0) {
      return Promise.resolve(true);
    }

    return Promise.resolve(false);
  }

  addToFolder(itemType, itemId, folderId) {
    var itemIdNumber = Number(itemId);
    var folderIdNumber = Number(folderId);
    return this.fetcher.addToFolder(itemType, itemIdNumber, folderIdNumber).then(r => {
      this.toggledStateBus.matches(mkKey(itemType, itemIdNumber)).forEach(cb => cb(true));
      this.favStorage.addToFolder(itemType, itemIdNumber, folderIdNumber);
      this.fetchAndEmitNumFavs(itemType, itemIdNumber);
      return r;
    });
  }

  removeFromFolder(itemType, itemId, folderId) {
    var itemIdNumber = Number(itemId);
    var folderIdNumber = Number(folderId);
    return this.fetcher.removeFromFolder(itemType, itemIdNumber, folderIdNumber).then(r => {
      this.favStorage.removeFromFolder(itemType, itemIdNumber, folderIdNumber);
      this.uncheckHeartIfRemovedFromAllFolders(itemType, itemIdNumber);
      this.fetchAndEmitNumFavs(itemType, itemIdNumber);
      return r;
    });
  }

  fetchFolders() {
    // [folderid]: {name, image}
    return this.fetcher.fetchFolders();
  }

  fetchFoldersForItem(itemType, itemId) {
    var itemIdNumber = Number(itemId);
    return Promise.resolve(mkItemFolder(itemType, itemIdNumber, this.favStorage.getFolderIds(itemType, itemIdNumber)));
  }

  createFolder(name) {
    return this.fetcher.createFolder(name);
  }

  deleteFolder(folderId) {
    var folderIdNumber = Number(folderId);
    return this.fetcher.deleteFolder(folderIdNumber).then(r => {
      this.favStorage.removeFolder(folderIdNumber);
      return r;
    });
  }

  static validateResponseOK(response) {
    if (response.ok) {
      return Promise.resolve(response);
    }

    return Promise.reject(response);
  }

  uncheckHeartIfRemovedFromAllFolders(itemType, itemIdNumber) {
    var folders = this.favStorage.getFolderIds(itemType, itemIdNumber);

    if (folders && folders.length < 1) {
      this.toggledStateBus.matches(mkKey(itemType, itemIdNumber)).forEach(cb => cb(false));
    }
  }

  fetchAndEmitNumFavs(itemType, itemId) {
    this.fetchNumFavs(itemType, itemId).then(FavoriteBrowserCache.validateResponseOK).then(res => this.emitFavCounter(res, itemType, itemId)).catch(res => this.emitZeroCountIfNotFound(res, itemType, itemId));
  }

  fetchNumFavs(itemType, itemId) {
    return this.fetcher.fetchNumFavs(itemType, itemId);
  }

  emitFavCounter(res, itemType, itemId) {
    return res.json().then(c => this.recountStateBus.emit(mkKey(itemType, itemId), c.counter)).catch(() => Promise.reject(res));
  }

  emitZeroCountIfNotFound(res, itemType, itemId) {
    if (res.status === 404) {
      this.recountStateBus.emit(mkKey(itemType, itemId), 0);
      return Promise.resolve(res);
    }

    return Promise.reject(res);
  }

}


//# sourceMappingURL=index.es.js.map

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../node_modules/compute-scroll-into-view/dist/index.module.js
function t(t){return"object"==typeof t&&null!=t&&1===t.nodeType}function e(t,e){return(!e||"hidden"!==t)&&"visible"!==t&&"clip"!==t}function n(t,n){if(t.clientHeight<t.scrollHeight||t.clientWidth<t.scrollWidth){var r=getComputedStyle(t,null);return e(r.overflowY,n)||e(r.overflowX,n)||function(t){var e=function(t){if(!t.ownerDocument||!t.ownerDocument.defaultView)return null;try{return t.ownerDocument.defaultView.frameElement}catch(t){return null}}(t);return!!e&&(e.clientHeight<t.scrollHeight||e.clientWidth<t.scrollWidth)}(t)}return!1}function r(t,e,n,r,i,o,l,d){return o<t&&l>e||o>t&&l<e?0:o<=t&&d<=n||l>=e&&d>=n?o-t-r:l>e&&d<n||o<t&&d>n?l-e+i:0}/* harmony default export */ function index_module(e,i){var o=window,l=i.scrollMode,d=i.block,u=i.inline,h=i.boundary,a=i.skipOverflowHiddenElements,c="function"==typeof h?h:function(t){return t!==h};if(!t(e))throw new TypeError("Invalid target");for(var f=document.scrollingElement||document.documentElement,s=[],p=e;t(p)&&c(p);){if((p=p.parentElement)===f){s.push(p);break}null!=p&&p===document.body&&n(p)&&!n(document.documentElement)||null!=p&&n(p,a)&&s.push(p)}for(var m=o.visualViewport?o.visualViewport.width:innerWidth,g=o.visualViewport?o.visualViewport.height:innerHeight,w=window.scrollX||pageXOffset,v=window.scrollY||pageYOffset,W=e.getBoundingClientRect(),b=W.height,H=W.width,y=W.top,E=W.right,M=W.bottom,V=W.left,x="start"===d||"nearest"===d?y:"end"===d?M:y+b/2,I="center"===u?V+H/2:"end"===u?E:V,C=[],T=0;T<s.length;T++){var k=s[T],B=k.getBoundingClientRect(),D=B.height,O=B.width,R=B.top,X=B.right,Y=B.bottom,L=B.left;if("if-needed"===l&&y>=0&&V>=0&&M<=g&&E<=m&&y>=R&&M<=Y&&V>=L&&E<=X)return C;var S=getComputedStyle(k),j=parseInt(S.borderLeftWidth,10),q=parseInt(S.borderTopWidth,10),z=parseInt(S.borderRightWidth,10),A=parseInt(S.borderBottomWidth,10),F=0,G=0,J="offsetWidth"in k?k.offsetWidth-k.clientWidth-j-z:0,K="offsetHeight"in k?k.offsetHeight-k.clientHeight-q-A:0;if(f===k)F="start"===d?x:"end"===d?x-g:"nearest"===d?r(v,v+g,g,q,A,v+x,v+x+b,b):x-g/2,G="start"===u?I:"center"===u?I-m/2:"end"===u?I-m:r(w,w+m,m,j,z,w+I,w+I+H,H),F=Math.max(0,F+v),G=Math.max(0,G+w);else{F="start"===d?x-R-q:"end"===d?x-Y+A+K:"nearest"===d?r(R,Y,D,q,A+K,x,x+b,b):x-(R+D/2)+K/2,G="start"===u?I-L-j:"center"===u?I-(L+O/2)+J/2:"end"===u?I-X+z+J:r(L,X,O,j,z+J,I,I+H,H);var N=k.scrollLeft,P=k.scrollTop;x+=P-(F=Math.max(0,Math.min(P+F,k.scrollHeight-D+K))),I+=N-(G=Math.max(0,Math.min(N+G,k.scrollWidth-O+J)))}C.push({el:k,top:F,left:G})}return C}
//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ../../node_modules/scroll-into-view-if-needed/es/index.js


function isOptionsObject(options) {
  return options === Object(options) && Object.keys(options).length !== 0;
}

function defaultBehavior(actions, behavior) {
  if (behavior === void 0) {
    behavior = 'auto';
  }

  var canSmoothScroll = ('scrollBehavior' in document.body.style);
  actions.forEach(function (_ref) {
    var el = _ref.el,
        top = _ref.top,
        left = _ref.left;

    if (el.scroll && canSmoothScroll) {
      el.scroll({
        top: top,
        left: left,
        behavior: behavior
      });
    } else {
      el.scrollTop = top;
      el.scrollLeft = left;
    }
  });
}

function getOptions(options) {
  if (options === false) {
    return {
      block: 'end',
      inline: 'nearest'
    };
  }

  if (isOptionsObject(options)) {
    return options;
  }

  return {
    block: 'start',
    inline: 'nearest'
  };
}

function scrollIntoView(target, options) {
  var targetIsDetached = !target.ownerDocument.documentElement.contains(target);

  if (isOptionsObject(options) && typeof options.behavior === 'function') {
    return options.behavior(targetIsDetached ? [] : index_module(target, options));
  }

  if (targetIsDetached) {
    return;
  }

  var computeOptions = getOptions(options);
  return defaultBehavior(index_module(target, computeOptions), computeOptions.behavior);
}

/* harmony default export */ var es = (scrollIntoView);
// EXTERNAL MODULE: ../../node_modules/@finn-no/favorite-heart-component/node_modules/classnames/index.js
var classnames = __webpack_require__(2985);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/@finn-no/troika-react-bottom-sheet/dist/index.es.js + 58 modules
var index_es = __webpack_require__(5058);
;// CONCATENATED MODULE: ../../node_modules/@finn-no/favorite-heart-component/node_modules/@finn-no/troika-react-buttons/dist/index.es.js



function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Button = /*#__PURE__*/(0,react.forwardRef)(function (_ref, forwardedRef) {
  var className = _ref.className,
      disabled = _ref.disabled,
      inProgress = _ref.inProgress,
      noBreak = _ref.noBreak,
      small = _ref.small,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'button' : _ref$type,
      props = _objectWithoutPropertiesLoose(_ref, ["className", "disabled", "inProgress", "noBreak", "small", "type"]);

  return /*#__PURE__*/(0,react.createElement)("button", _extends({}, props, {
    ref: forwardedRef,
    className: classnames_default()('button', className, {
      'button--is-disabled': !inProgress && disabled,
      'button--in-progress': inProgress,
      'button--small': small,
      'button--no-break': noBreak
    }),
    disabled: disabled || inProgress,
    type: type
  }));
});
var CallToActionButton = /*#__PURE__*/(0,react.forwardRef)(function (_ref2, forwardedRef) {
  var className = _ref2.className,
      props = _objectWithoutPropertiesLoose(_ref2, ["className"]);

  return /*#__PURE__*/(0,react.createElement)(Button, _extends({}, props, {
    ref: forwardedRef,
    className: classnames_default()(className, 'button--cta')
  }));
});
var DefaultButton = /*#__PURE__*/(0,react.forwardRef)(function (_ref3, forwardedRef) {
  var className = _ref3.className,
      props = _objectWithoutPropertiesLoose(_ref3, ["className"]);

  return /*#__PURE__*/(0,react.createElement)(Button, _extends({}, props, {
    ref: forwardedRef,
    className: classnames_default()(className, 'button--default')
  }));
});
var OrderButton = /*#__PURE__*/(0,react.forwardRef)(function (_ref4, forwardedRef) {
  var className = _ref4.className,
      props = _objectWithoutPropertiesLoose(_ref4, ["className"]);

  return /*#__PURE__*/(0,react.createElement)(Button, _extends({}, props, {
    ref: forwardedRef,
    className: classnames_default()(className, 'button--order')
  }));
});
var DestructiveButton = /*#__PURE__*/(0,react.forwardRef)(function (_ref5, forwardedRef) {
  var className = _ref5.className,
      props = _objectWithoutPropertiesLoose(_ref5, ["className"]);

  return /*#__PURE__*/(0,react.createElement)(Button, _extends({}, props, {
    ref: forwardedRef,
    className: classnames_default()(className, 'button--destructive')
  }));
});
var DestructiveFlatButton = /*#__PURE__*/(0,react.forwardRef)(function (_ref6, forwardedRef) {
  var className = _ref6.className,
      props = _objectWithoutPropertiesLoose(_ref6, ["className"]);

  return /*#__PURE__*/(0,react.createElement)(Button, _extends({}, props, {
    ref: forwardedRef,
    className: classnames_default()(className, 'button--destructive-flat')
  }));
});
var FlatButton = /*#__PURE__*/(0,react.forwardRef)(function (_ref7, forwardedRef) {
  var className = _ref7.className,
      props = _objectWithoutPropertiesLoose(_ref7, ["className"]);

  return /*#__PURE__*/(0,react.createElement)(Button, _extends({}, props, {
    ref: forwardedRef,
    className: classnames_default()(className, 'button--flat')
  }));
});
Button.displayName = "Button";
CallToActionButton.displayName = "CallToActionButton";
DefaultButton.displayName = "DefaultButton";
OrderButton.displayName = "OrderButton";
DestructiveButton.displayName = "DestructiveButton";
DestructiveFlatButton.displayName = "DestructiveFlatButton";
FlatButton.displayName = "FlatButton";

var LinkButton = /*#__PURE__*/(0,react.forwardRef)( // TODO: remove use of <Button /> here, instead render a <button /> ourselves?
// I don't think LinkButton supports in progress, for instance, but leaving as it was for now
function (_ref, forwardedRef) {
  var className = _ref.className,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'button' : _ref$type,
      props = _objectWithoutPropertiesLoose(_ref, ["className", "type"]);

  return /*#__PURE__*/(0,react.createElement)(Button, _extends({}, props, {
    className: classnames_default()(className, 'button--link'),
    ref: forwardedRef,
    type: type
  }));
});
LinkButton.displayName = "LinkButton";


//# sourceMappingURL=index.es.js.map

// EXTERNAL MODULE: ../../node_modules/warning/warning.js
var warning = __webpack_require__(5982);
var warning_default = /*#__PURE__*/__webpack_require__.n(warning);
;// CONCATENATED MODULE: ../../node_modules/@reach/dialog/node_modules/@reach/utils/dist/utils.esm.js




/* eslint-disable no-restricted-globals, eqeqeq  */
/**
 * React currently throws a warning when using useLayoutEffect on the server.
 * To get around it, we can conditionally useEffect on the server (no-op) and
 * useLayoutEffect in the browser. We occasionally need useLayoutEffect to
 * ensure we don't get a render flash for certain operations, but we may also
 * need affected components to render on the server. One example is when setting
 * a component's descendants to retrieve their index values.
 *
 * Important to note that using this hook as an escape hatch will break the
 * eslint dependency warnings unless you rename the import to `useLayoutEffect`.
 * Use sparingly only when the effect won't effect the rendered HTML to avoid
 * any server/client mismatch.
 *
 * If a useLayoutEffect is needed and the result would create a mismatch, it's
 * likely that the component in question shouldn't be rendered on the server at
 * all, so a better approach would be to lazily render those in a parent
 * component after client-side hydration.
 *
 * TODO: We are calling useLayoutEffect in a couple of places that will likely
 * cause some issues for SSR users, whether the warning shows or not. Audit and
 * fix these.
 *
 * https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * https://github.com/reduxjs/react-redux/blob/master/src/utils/useIsomorphicLayoutEffect.js
 *
 * @param effect
 * @param deps
 */

var useIsomorphicLayoutEffect = /*#__PURE__*/canUseDOM() ? react.useLayoutEffect : react.useEffect;
var checkedPkgs = {};
/**
 * Copy of Facebook's warning package.
 *
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical paths.
 * Removing the logging code for production environments will keep the same
 * logic and follow the same code paths.
 *
 * @see https://github.com/BerkeleyTrue/warning/blob/master/warning.js
 */

var utils_esm_warning = (warning_default());
/**
 * When in dev mode, checks that styles for a given @reach package are loaded.
 *
 * @param packageName Name of the package to check.
 * @example checkStyles("dialog") will check for styles for @reach/dialog
 */

var checkStyles = utils_esm_noop;

if (false) { var _ref, env; }
/**
 * Ponyfill for the global object in some environments.
 *
 * @link https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
 */

var ponyfillGlobal = typeof window != "undefined" && window.Math == Math ? window : typeof self != "undefined" && self.Math == Math ? self :
/*#__PURE__*/
// eslint-disable-next-line no-new-func
Function("return this")();
/**
 * Passes or assigns an arbitrary value to a ref function or object.
 *
 * @param ref
 * @param value
 */

function assignRef(ref, value) {
  if (ref == null) return;

  if (isFunction(ref)) {
    ref(value);
  } else {
    try {
      ref.current = value;
    } catch (error) {
      throw new Error("Cannot assign value \"" + value + "\" to ref \"" + ref + "\"");
    }
  }
}
/**
 * Checks true|"true" vs false|"false"
 *
 * @param value
 */

function boolOrBoolString(value) {
  return value === "true" ? true : isBoolean(value) ? value : false;
}
function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}
/**
 * Type-safe clone element
 *
 * @param element
 * @param props
 * @param children
 */

function cloneValidElement(element, props) {
  for (var _len = arguments.length, children = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    children[_key - 2] = arguments[_key];
  }

  return isValidElement(element) ? cloneElement.apply(React, [element, props].concat(children)) : element;
}
function createNamedContext(name, defaultValue) {
  var Ctx = createContext(defaultValue);
  Ctx.displayName = name;
  return Ctx;
}
/**
 * This is a hack for sure. The thing is, getting a component to intelligently
 * infer props based on a component or JSX string passed into an `as` prop is
 * kind of a huge pain. Getting it to work and satisfy the constraints of
 * `forwardRef` seems dang near impossible. To avoid needing to do this awkward
 * type song-and-dance every time we want to forward a ref into a component
 * that accepts an `as` prop, we abstract all of that mess to this function for
 * the time time being.
 */

function utils_esm_forwardRefWithAs(render) {
  return (0,react.forwardRef)(render);
}
function memoWithAs(Component, propsAreEqual) {
  return memo(Component, propsAreEqual);
}
/**
 * Get the size of the working document minus the scrollbar offset.
 *
 * @param element
 */

function getDocumentDimensions(element) {
  var _ownerDocument$docume, _ownerDocument$docume2;

  var ownerDocument = getOwnerDocument(element);
  var ownerWindow = ownerDocument.defaultView || window;

  if (!ownerDocument) {
    return {
      width: 0,
      height: 0
    };
  }

  return {
    width: (_ownerDocument$docume = ownerDocument.documentElement.clientWidth) !== null && _ownerDocument$docume !== void 0 ? _ownerDocument$docume : ownerWindow.innerWidth,
    height: (_ownerDocument$docume2 = ownerDocument.documentElement.clientHeight) !== null && _ownerDocument$docume2 !== void 0 ? _ownerDocument$docume2 : ownerWindow.innerHeight
  };
}
/**
 * Get the scoll position of the global window object relative to a given node.
 *
 * @param element
 */

function getScrollPosition(element) {
  var ownerDocument = getOwnerDocument(element);
  var ownerWindow = ownerDocument.defaultView || window;

  if (!ownerDocument) {
    return {
      scrollX: 0,
      scrollY: 0
    };
  }

  return {
    scrollX: ownerWindow.scrollX,
    scrollY: ownerWindow.scrollY
  };
}
/**
 * Get a computed style value by property.
 *
 * @param element
 * @param styleProp
 */

function getElementComputedStyle(element, styleProp) {
  var ownerDocument = getOwnerDocument(element);
  var ownerWindow = (ownerDocument === null || ownerDocument === void 0 ? void 0 : ownerDocument.defaultView) || window;

  if (ownerWindow) {
    return ownerWindow.getComputedStyle(element, null).getPropertyValue(styleProp);
  }

  return null;
}
/**
 * Get an element's owner document. Useful when components are used in iframes
 * or other environments like dev tools.
 *
 * @param element
 */

function getOwnerDocument(element) {
  return canUseDOM() ? element ? element.ownerDocument : document : null;
}
/**
 * TODO: Remove in 1.0
 */

function getOwnerWindow(element) {
  var ownerDocument = getOwnerDocument(element);
  return ownerDocument ? ownerDocument.defaultView || window : null;
}
/**
 * Get the scrollbar offset distance.
 *
 * TODO: Remove in 1.0 (we used this in public examples)
 */

function getScrollbarOffset() {
  try {
    if (window.innerWidth > document.documentElement.clientWidth) {
      return window.innerWidth - document.documentElement.clientWidth;
    }
  } catch (err) {}

  return 0;
}
/**
 * Checks whether or not a value is a boolean.
 *
 * @param value
 */

function isBoolean(value) {
  return typeof value === "boolean";
}
/**
 * Checks whether or not a value is a function.
 *
 * @param value
 */

function isFunction(value) {
  return !!(value && {}.toString.call(value) == "[object Function]");
}
/**
 * Checks whether or not a value is a number.
 *
 * @param value
 */

function isNumber(value) {
  return typeof value === "number" && !isNaN(value);
}
/**
 * Detects right clicks
 *
 * @param nativeEvent
 */

function isRightClick(nativeEvent) {
  return "which" in nativeEvent ? nativeEvent.which === 3 : "button" in nativeEvent ? nativeEvent.button === 2 : false;
}
/**
 * Checks whether or not a value is a string.
 *
 * @param value
 */

function utils_esm_isString(value) {
  return typeof value === "string";
}
/**
 * Joins strings to format IDs for compound components.
 *
 * @param args
 */

function makeId() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  return args.filter(function (val) {
    return val != null;
  }).join("--");
}
/**
 * No-op function.
 */

function utils_esm_noop() {}
/**
 * Convert our state strings for HTML data attributes.
 * No need for a fancy kebab-caser here, we know what our state strings are!
 *
 * @param state
 */

function stateToAttributeString(state) {
  return String(state).replace(/([\s_]+)/g, "-").toLowerCase();
}
/**
 * Check if a component is controlled or uncontrolled and return the correct
 * state value and setter accordingly. If the component state is controlled by
 * the app, the setter is a noop.
 *
 * @param controlledValue
 * @param defaultValue
 */

function useControlledState(controlledValue, defaultValue) {
  var controlledRef = useRef(controlledValue != null);

  var _React$useState = useState(defaultValue),
      valueState = _React$useState[0],
      setValue = _React$useState[1];

  var set = useCallback(function (n) {
    if (!controlledRef.current) {
      setValue(n);
    }
  }, []);
  return [controlledRef.current ? controlledValue : valueState, set];
}
/**
 * Logs a warning in dev mode when a component switches from controlled to
 * uncontrolled, or vice versa
 *
 * A single prop should typically be used to determine whether or not a
 * component is controlled or not.
 *
 * @param controlledValue
 * @param controlledPropName
 * @param componentName
 */

var useControlledSwitchWarning = (/* unused pure expression or super */ null && (utils_esm_noop));

if (false) {}
var useCheckStyles = utils_esm_noop;

if (false) {}
/**
 * React hook for creating a value exactly once.
 * @see https://github.com/Andarist/use-constant
 */

function useConstant(fn) {
  var ref = useRef();

  if (!ref.current) {
    ref.current = {
      v: fn()
    };
  }

  return ref.current.v;
}
/**
 * @param callback
 */

function useEventCallback(callback) {
  var ref = useRef(callback);
  useIsomorphicLayoutEffect(function () {
    ref.current = callback;
  });
  return useCallback(function (event) {
    for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      args[_key3 - 1] = arguments[_key3];
    }

    return ref.current.apply(ref, [event].concat(args));
  }, []);
}
function useLazyRef(fn) {
  var ref = useRef({
    __internalSet: true
  });

  if (ref.current && ref.current.__internalSet === true) {
    ref.current = fn();
  }

  return ref;
}
/**
 * TODO: Remove in 1.0
 * @alias useStableCallback
 * @param callback
 */

var useCallbackProp = useStableCallback;
/**
 * Adds a DOM event listener
 *
 * @param eventName
 * @param listener
 * @param element
 */

function useEventListener(eventName, listener, element) {
  if (element === void 0) {
    element = window;
  }

  var savedHandler = useRef(listener);
  useEffect(function () {
    savedHandler.current = listener;
  }, [listener]);
  useEffect(function () {
    var isSupported = element && element.addEventListener;

    if (!isSupported) {
      if (false) {}

      return;
    }

    function eventListener(event) {
      savedHandler.current(event);
    }

    element.addEventListener(eventName, eventListener);
    return function () {
      element.removeEventListener(eventName, eventListener);
    };
  }, [eventName, element]);
}
/**
 * Detect when focus changes in our document.
 *
 * @param handleChange
 * @param when
 * @param ownerDocument
 */

function useFocusChange(handleChange, when, ownerDocument) {
  if (handleChange === void 0) {
    handleChange = console.log;
  }

  if (when === void 0) {
    when = "focus";
  }

  if (ownerDocument === void 0) {
    ownerDocument = document;
  }

  var lastActiveElement = useRef(ownerDocument.activeElement);
  useEffect(function () {
    lastActiveElement.current = ownerDocument.activeElement;

    function onChange(event) {
      if (lastActiveElement.current !== ownerDocument.activeElement) {
        handleChange(ownerDocument.activeElement, lastActiveElement.current, event);
        lastActiveElement.current = ownerDocument.activeElement;
      }
    }

    ownerDocument.addEventListener(when, onChange, true);
    return function () {
      ownerDocument.removeEventListener(when, onChange);
    };
  }, [when, handleChange, ownerDocument]);
}
/**
 * Forces a re-render, similar to `forceUpdate` in class components.
 */

function useForceUpdate() {
  var _React$useState2 = (0,react.useState)(Object.create(null)),
      dispatch = _React$useState2[1];

  return (0,react.useCallback)(function () {
    dispatch(Object.create(null));
  }, []);
}
/**
 * Passes or assigns a value to multiple refs (typically a DOM node). Useful for
 * dealing with components that need an explicit ref for DOM calculations but
 * also forwards refs assigned by an app.
 *
 * @param refs Refs to fork
 */

function useForkedRef() {
  for (var _len4 = arguments.length, refs = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    refs[_key4] = arguments[_key4];
  }

  return (0,react.useMemo)(function () {
    if (refs.every(function (ref) {
      return ref == null;
    })) {
      return null;
    }

    return function (node) {
      refs.forEach(function (ref) {
        assignRef(ref, node);
      });
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [].concat(refs));
}
/**
 * Returns the previous value of a reference after a component update.
 *
 * @param value
 */

function usePrevious(value) {
  var ref = useRef(null);
  useEffect(function () {
    ref.current = value;
  }, [value]);
  return ref.current;
}
/**
 * Converts a callback to a ref to avoid triggering re-renders when passed as a
 * prop and exposed as a stable function to avoid executing effects when
 * passed as a dependency.
 */

function useStableCallback(callback) {
  var callbackRef = (0,react.useRef)(callback);
  (0,react.useEffect)(function () {
    callbackRef.current = callback;
  }); // eslint-disable-next-line react-hooks/exhaustive-deps

  return (0,react.useCallback)(function () {
    callbackRef.current && callbackRef.current.apply(callbackRef, arguments);
  }, []);
}
/**
 * Call an effect after a component update, skipping the initial mount.
 *
 * @param effect Effect to call
 * @param deps Effect dependency list
 */

function useUpdateEffect(effect, deps) {
  var mounted = useRef(false);
  useEffect(function () {
    if (mounted.current) {
      effect();
    } else {
      mounted.current = true;
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, deps);
}
/**
 * Just a lil state logger
 *
 * @param state
 * @param DEBUG
 */

var useStateLogger = (/* unused pure expression or super */ null && (utils_esm_noop));

if (false) {}
/**
 * Wraps a lib-defined event handler and a user-defined event handler, returning
 * a single handler that allows a user to prevent lib-defined handlers from
 * firing.
 *
 * @param theirHandler User-supplied event handler
 * @param ourHandler Library-supplied event handler
 */

function wrapEvent(theirHandler, ourHandler) {
  return function (event) {
    theirHandler && theirHandler(event);

    if (!event.defaultPrevented) {
      return ourHandler(event);
    }
  };
}


//# sourceMappingURL=utils.esm.js.map

// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(8316);
;// CONCATENATED MODULE: ../../node_modules/@reach/dialog/node_modules/@reach/portal/dist/portal.esm.js




/**
 * Welcome to @reach/portal!
 *
 * Creates and appends a DOM node to the end of `document.body` and renders a
 * React tree into it. Useful for rendering a natural React element hierarchy
 * with a different DOM hierarchy to prevent parent styles from clipping or
 * hiding content (for popovers, dropdowns, and modals).
 *
 * @see Docs   https://reach.tech/portal
 * @see Source https://github.com/reach/reach-ui/tree/main/packages/portal
 * @see React  https://reactjs.org/docs/portals.html
 */
/**
 * Portal
 *
 * @see Docs https://reach.tech/portal#portal
 */

var Portal = function Portal(_ref) {
  var children = _ref.children,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "reach-portal" : _ref$type;
  var mountNode = (0,react.useRef)(null);
  var portalNode = (0,react.useRef)(null);
  var forceUpdate = useForceUpdate();
  useIsomorphicLayoutEffect(function () {
    // This ref may be null when a hot-loader replaces components on the page
    if (!mountNode.current) return; // It's possible that the content of the portal has, itself, been portaled.
    // In that case, it's important to append to the correct document element.

    var ownerDocument = mountNode.current.ownerDocument;
    portalNode.current = ownerDocument === null || ownerDocument === void 0 ? void 0 : ownerDocument.createElement(type);
    ownerDocument.body.appendChild(portalNode.current);
    forceUpdate();
    return function () {
      if (portalNode.current && portalNode.current.ownerDocument) {
        portalNode.current.ownerDocument.body.removeChild(portalNode.current);
      }
    };
  }, [type, forceUpdate]);
  return portalNode.current ? (0,react_dom.createPortal)(children, portalNode.current) : (0,react.createElement)("span", {
    ref: mountNode
  });
};

if (false) {} ////////////////////////////////////////////////////////////////////////////////

/* harmony default export */ var portal_esm = ((/* unused pure expression or super */ null && (Portal)));

//# sourceMappingURL=portal.esm.js.map

// EXTERNAL MODULE: ../../node_modules/react-focus-lock/dist/es2015/index.js + 27 modules
var es2015 = __webpack_require__(3547);
// EXTERNAL MODULE: ../../node_modules/react-remove-scroll/dist/es2015/Combination.js + 17 modules
var Combination = __webpack_require__(423);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(3980);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ../../node_modules/@reach/dialog/dist/dialog.esm.js







function dialog_esm_extends() {
  dialog_esm_extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return dialog_esm_extends.apply(this, arguments);
}

function dialog_esm_objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var overlayPropTypes = {
  allowPinchZoom: (prop_types_default()).bool,
  dangerouslyBypassFocusLock: (prop_types_default()).bool,
  dangerouslyBypassScrollLock: (prop_types_default()).bool,
  // TODO:
  initialFocusRef: function initialFocusRef() {
    return null;
  },
  onDismiss: (prop_types_default()).func
}; ////////////////////////////////////////////////////////////////////////////////

/**
 * DialogOverlay
 *
 * Low-level component if you need more control over the styles or rendering of
 * the dialog overlay.
 *
 * Note: You must render a `DialogContent` inside.
 *
 * @see Docs https://reach.tech/dialog#dialogoverlay
 */

var DialogOverlay = /*#__PURE__*/utils_esm_forwardRefWithAs(function DialogOverlay(_ref, forwardedRef) {
  var _ref$as = _ref.as,
      Comp = _ref$as === void 0 ? "div" : _ref$as,
      _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === void 0 ? true : _ref$isOpen,
      props = dialog_esm_objectWithoutPropertiesLoose(_ref, ["as", "isOpen"]);

  useCheckStyles("dialog"); // We want to ignore the immediate focus of a tooltip so it doesn't pop
  // up again when the menu closes, only pops up when focus returns again
  // to the tooltip (like native OS tooltips).

  (0,react.useEffect)(function () {
    if (isOpen) {
      // @ts-ignore
      window.__REACH_DISABLE_TOOLTIPS = true;
    } else {
      window.requestAnimationFrame(function () {
        // Wait a frame so that this doesn't fire before tooltip does
        // @ts-ignore
        window.__REACH_DISABLE_TOOLTIPS = false;
      });
    }
  }, [isOpen]);
  return isOpen ? (0,react.createElement)(Portal, {
    "data-reach-dialog-wrapper": ""
  }, (0,react.createElement)(DialogInner, Object.assign({
    ref: forwardedRef,
    as: Comp
  }, props))) : null;
});

if (false) {} ////////////////////////////////////////////////////////////////////////////////

/**
 * DialogInner
 */


var DialogInner = /*#__PURE__*/utils_esm_forwardRefWithAs(function DialogInner(_ref2, forwardedRef) {
  var allowPinchZoom = _ref2.allowPinchZoom,
      _ref2$as = _ref2.as,
      Comp = _ref2$as === void 0 ? "div" : _ref2$as,
      _ref2$dangerouslyBypa = _ref2.dangerouslyBypassFocusLock,
      dangerouslyBypassFocusLock = _ref2$dangerouslyBypa === void 0 ? false : _ref2$dangerouslyBypa,
      _ref2$dangerouslyBypa2 = _ref2.dangerouslyBypassScrollLock,
      dangerouslyBypassScrollLock = _ref2$dangerouslyBypa2 === void 0 ? false : _ref2$dangerouslyBypa2,
      initialFocusRef = _ref2.initialFocusRef,
      onClick = _ref2.onClick,
      _ref2$onDismiss = _ref2.onDismiss,
      onDismiss = _ref2$onDismiss === void 0 ? utils_esm_noop : _ref2$onDismiss,
      onKeyDown = _ref2.onKeyDown,
      onMouseDown = _ref2.onMouseDown,
      _ref2$unstable_lockFo = _ref2.unstable_lockFocusAcrossFrames,
      unstable_lockFocusAcrossFrames = _ref2$unstable_lockFo === void 0 ? true : _ref2$unstable_lockFo,
      props = dialog_esm_objectWithoutPropertiesLoose(_ref2, ["allowPinchZoom", "as", "dangerouslyBypassFocusLock", "dangerouslyBypassScrollLock", "initialFocusRef", "onClick", "onDismiss", "onKeyDown", "onMouseDown", "unstable_lockFocusAcrossFrames"]);

  var mouseDownTarget = (0,react.useRef)(null);
  var overlayNode = (0,react.useRef)(null);
  var ref = useForkedRef(overlayNode, forwardedRef);
  var activateFocusLock = (0,react.useCallback)(function () {
    if (initialFocusRef && initialFocusRef.current) {
      initialFocusRef.current.focus();
    }
  }, [initialFocusRef]);

  function handleClick(event) {
    if (mouseDownTarget.current === event.target) {
      event.stopPropagation();
      onDismiss(event);
    }
  }

  function handleKeyDown(event) {
    if (event.key === "Escape") {
      event.stopPropagation();
      onDismiss(event);
    }
  }

  function handleMouseDown(event) {
    mouseDownTarget.current = event.target;
  }

  (0,react.useEffect)(function () {
    return overlayNode.current ? createAriaHider(overlayNode.current) : void null;
  }, []);
  return (0,react.createElement)(es2015/* default */.ZP, {
    autoFocus: true,
    returnFocus: true,
    onActivation: activateFocusLock,
    disabled: dangerouslyBypassFocusLock,
    crossFrame: unstable_lockFocusAcrossFrames
  }, (0,react.createElement)(Combination/* default */.Z, {
    allowPinchZoom: allowPinchZoom,
    enabled: !dangerouslyBypassScrollLock
  }, (0,react.createElement)(Comp, Object.assign({}, props, {
    ref: ref,
    "data-reach-dialog-overlay": "",

    /*
     * We can ignore the `no-static-element-interactions` warning here
     * because our overlay is only designed to capture any outside
     * clicks, not to serve as a clickable element itself.
     */
    onClick: wrapEvent(onClick, handleClick),
    onKeyDown: wrapEvent(onKeyDown, handleKeyDown),
    onMouseDown: wrapEvent(onMouseDown, handleMouseDown)
  }))));
});

if (false) {} ////////////////////////////////////////////////////////////////////////////////

/**
 * DialogContent
 *
 * Low-level component if you need more control over the styles or rendering of
 * the dialog content.
 *
 * Note: Must be a child of `DialogOverlay`.
 *
 * Note: You only need to use this when you are also styling `DialogOverlay`,
 * otherwise you can use the high-level `Dialog` component and pass the props
 * to it. Any props passed to `Dialog` component (besides `isOpen` and
 * `onDismiss`) will be spread onto `DialogContent`.
 *
 * @see Docs https://reach.tech/dialog#dialogcontent
 */


var DialogContent = /*#__PURE__*/utils_esm_forwardRefWithAs(function DialogContent(_ref3, forwardedRef) {
  var _ref3$as = _ref3.as,
      Comp = _ref3$as === void 0 ? "div" : _ref3$as,
      onClick = _ref3.onClick,
      onKeyDown = _ref3.onKeyDown,
      props = dialog_esm_objectWithoutPropertiesLoose(_ref3, ["as", "onClick", "onKeyDown"]);

  return (0,react.createElement)(Comp, Object.assign({
    "aria-modal": "true",
    role: "dialog",
    tabIndex: -1
  }, props, {
    ref: forwardedRef,
    "data-reach-dialog-content": "",
    onClick: wrapEvent(onClick, function (event) {
      event.stopPropagation();
    })
  }));
});

if (false) {} ////////////////////////////////////////////////////////////////////////////////

/**
 * Dialog
 *
 * High-level component to render a modal dialog window over the top of the page
 * (or another dialog).
 *
 * @see Docs https://reach.tech/dialog#dialog
 */


var Dialog = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRefWithAs(function Dialog(_ref4, forwardedRef) {
  var _ref4$allowPinchZoom = _ref4.allowPinchZoom,
      allowPinchZoom = _ref4$allowPinchZoom === void 0 ? false : _ref4$allowPinchZoom,
      initialFocusRef = _ref4.initialFocusRef,
      isOpen = _ref4.isOpen,
      _ref4$onDismiss = _ref4.onDismiss,
      onDismiss = _ref4$onDismiss === void 0 ? noop : _ref4$onDismiss,
      props = dialog_esm_objectWithoutPropertiesLoose(_ref4, ["allowPinchZoom", "initialFocusRef", "isOpen", "onDismiss"]);

  return createElement(DialogOverlay, {
    allowPinchZoom: allowPinchZoom,
    initialFocusRef: initialFocusRef,
    isOpen: isOpen,
    onDismiss: onDismiss
  }, createElement(DialogContent, Object.assign({
    ref: forwardedRef
  }, props)));
})));

if (false) {} ////////////////////////////////////////////////////////////////////////////////


function createAriaHider(dialogNode) {
  var originalValues = [];
  var rootNodes = [];
  var ownerDocument = getOwnerDocument(dialogNode);

  if (!dialogNode) {
    if (false) {}

    return utils_esm_noop;
  }

  Array.prototype.forEach.call(ownerDocument.querySelectorAll("body > *"), function (node) {
    var _dialogNode$parentNod, _dialogNode$parentNod2;

    var portalNode = (_dialogNode$parentNod = dialogNode.parentNode) === null || _dialogNode$parentNod === void 0 ? void 0 : (_dialogNode$parentNod2 = _dialogNode$parentNod.parentNode) === null || _dialogNode$parentNod2 === void 0 ? void 0 : _dialogNode$parentNod2.parentNode;

    if (node === portalNode) {
      return;
    }

    var attr = node.getAttribute("aria-hidden");
    var alreadyHidden = attr !== null && attr !== "false";

    if (alreadyHidden) {
      return;
    }

    originalValues.push(attr);
    rootNodes.push(node);
    node.setAttribute("aria-hidden", "true");
  });
  return function () {
    rootNodes.forEach(function (node, index) {
      var originalValue = originalValues[index];

      if (originalValue === null) {
        node.removeAttribute("aria-hidden");
      } else {
        node.setAttribute("aria-hidden", originalValue);
      }
    });
  };
}

function ariaLabelType(props, propName, compName, location, propFullName) {
  var details = "\nSee https://www.w3.org/TR/wai-aria/#aria-label for details.";

  if (!props["aria-label"] && !props["aria-labelledby"]) {
    return new Error("A <" + compName + "> must have either an `aria-label` or `aria-labelledby` prop.\n      " + details);
  }

  if (props["aria-label"] && props["aria-labelledby"]) {
    return new Error("You provided both `aria-label` and `aria-labelledby` props to a <" + compName + ">. If the a label for this component is visible on the screen, that label's component should be given a unique ID prop, and that ID should be passed as the `aria-labelledby` prop into <" + compName + ">. If the label cannot be determined programmatically from the content of the element, an alternative label should be provided as the `aria-label` prop, which will be used as an `aria-label` on the HTML tag." + details);
  } else if (props[propName] != null && !isString(props[propName])) {
    return new Error("Invalid prop `" + propName + "` supplied to `" + compName + "`. Expected `string`, received `" + (Array.isArray(propFullName) ? "array" : typeof propFullName) + "`.");
  }

  return null;
}

/* harmony default export */ var dialog_esm = ((/* unused pure expression or super */ null && (Dialog)));

//# sourceMappingURL=dialog.esm.js.map

// EXTERNAL MODULE: ../../node_modules/@finn-no/troika-react-modal/node_modules/classnames/index.js
var node_modules_classnames = __webpack_require__(9067);
var node_modules_classnames_default = /*#__PURE__*/__webpack_require__.n(node_modules_classnames);
;// CONCATENATED MODULE: ../../node_modules/@finn-no/troika-react-modal/dist/index.es.js




function index_es_extends() {
  index_es_extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return index_es_extends.apply(this, arguments);
}

function index_es_objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Modal = function Modal(_ref) {
  var children = _ref.children,
      className = _ref.className,
      initialFocusRef = _ref.initialFocusRef,
      isOpen = _ref.isOpen,
      max640 = _ref.max640,
      onDismiss = _ref.onDismiss,
      roomy = _ref.roomy,
      props = index_es_objectWithoutPropertiesLoose(_ref, ["children", "className", "initialFocusRef", "isOpen", "max640", "onDismiss", "roomy"]);

  (0,react.useEffect)(function () {
    if (isOpen) {
      document.body.classList.add('modal--document-body');
      return function () {
        return document.body.classList.remove('modal--document-body');
      };
    }
  }, [isOpen]);
  var overlayClassName = node_modules_classnames_default()('modal modal--is-active', props.overlayClassName, {
    'modal--is-max640': max640,
    'modal--is-roomy': roomy
  });
  var containerClassName = node_modules_classnames_default()('modal__container', className);
  return /*#__PURE__*/(0,react.createElement)(DialogOverlay, {
    allowPinchZoom: true,
    className: overlayClassName,
    initialFocusRef: initialFocusRef,
    isOpen: isOpen,
    onDismiss: onDismiss
  }, /*#__PURE__*/(0,react.createElement)(DialogContent, index_es_extends({
    className: containerClassName
  }, props), children));
};
Modal.displayName = "Modal";

var ModalContent = function ModalContent(_ref) {
  var className = _ref.className,
      props = index_es_objectWithoutPropertiesLoose(_ref, ["className"]);

  return /*#__PURE__*/(0,react.createElement)("div", index_es_extends({
    className: node_modules_classnames_default()('modal__content', className)
  }, props));
};

ModalContent.displayName = "ModalContent";

var ModalFooter = function ModalFooter(_ref) {
  var className = _ref.className,
      props = index_es_objectWithoutPropertiesLoose(_ref, ["className"]);

  return /*#__PURE__*/(0,react.createElement)("div", index_es_extends({
    className: node_modules_classnames_default()('modal__footer', className)
  }, props));
};

ModalFooter.displayName = "ModalFooter";

/* harmony default export */ var dist_index_es = ((/* unused pure expression or super */ null && (Modal)));

//# sourceMappingURL=index.es.js.map

// EXTERNAL MODULE: ../../node_modules/@finn-no/troika-react-panel/node_modules/classnames/index.js
var troika_react_panel_node_modules_classnames = __webpack_require__(2407);
var troika_react_panel_node_modules_classnames_default = /*#__PURE__*/__webpack_require__.n(troika_react_panel_node_modules_classnames);
;// CONCATENATED MODULE: ../../node_modules/@finn-no/troika-react-panel/dist/index.es.js



function dist_index_es_extends() {
  dist_index_es_extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return dist_index_es_extends.apply(this, arguments);
}

function dist_index_es_objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Panel = function Panel(_ref) {
  var className = _ref.className,
      children = _ref.children,
      clickable = _ref.clickable,
      type = _ref.type,
      roomy = _ref.roomy,
      bordered = _ref.bordered,
      killLastMargin = _ref.killLastMargin,
      rest = dist_index_es_objectWithoutPropertiesLoose(_ref, ["className", "children", "clickable", "type", "roomy", "bordered", "killLastMargin"]);

  return /*#__PURE__*/react.createElement("div", dist_index_es_extends({}, rest, {
    className: troika_react_panel_node_modules_classnames_default()('panel', {
      'panel--info': type === 'info',
      'panel--tips': type === 'tips',
      'panel--new': type === 'new',
      'panel--success': type === 'success',
      'panel--warning': type === 'warning',
      'panel--error': type === 'error',
      'panel--bleed': type === 'bleed',
      'panel--bright': type === 'bright',
      'panel--neutral': type === 'neutral',
      'panel--bordered': bordered,
      'panel--is-clickable': clickable,
      'panel--is-roomy': roomy,
      'panel--kill-last-margin': killLastMargin
    }, className)
  }), children);
};

Panel.displayName = "Panel";

/* harmony default export */ var troika_react_panel_dist_index_es = (Panel);
//# sourceMappingURL=index.es.js.map

// EXTERNAL MODULE: ../../node_modules/@finn-no/analytics/lib/client/index.js
var client = __webpack_require__(7165);
// EXTERNAL MODULE: ../../node_modules/@finn-no/favorite-heart-component/node_modules/@finn-no/pulse-sdk/dist/client.min.js
var client_min = __webpack_require__(5105);
var client_min_default = /*#__PURE__*/__webpack_require__.n(client_min);
// EXTERNAL MODULE: ../../node_modules/@finn-no/troika-react-pagination/node_modules/classnames/index.js
var troika_react_pagination_node_modules_classnames = __webpack_require__(3769);
var troika_react_pagination_node_modules_classnames_default = /*#__PURE__*/__webpack_require__.n(troika_react_pagination_node_modules_classnames);
;// CONCATENATED MODULE: ../../node_modules/@finn-no/troika-react-pagination/dist/index.es.js



function troika_react_pagination_dist_index_es_extends() {
  troika_react_pagination_dist_index_es_extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return troika_react_pagination_dist_index_es_extends.apply(this, arguments);
}

function troika_react_pagination_dist_index_es_objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var PaginationContext = /*#__PURE__*/(0,react.createContext)({
  currentPage: 0,
  lastPage: 0
});
var usePagination = function usePagination() {
  return (0,react.useContext)(PaginationContext);
};
var PaginationContainer = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      className = _ref.className,
      currentPage = _ref.currentPage,
      lastPage = _ref.lastPage,
      _ref$ariaLabelledby = _ref['aria-labelledby'],
      ariaLabelledBy = _ref$ariaLabelledby === void 0 ? 'pagination-heading' : _ref$ariaLabelledby,
      _ref$ariaLabel = _ref['aria-label'],
      ariaLabel = _ref$ariaLabel === void 0 ? 'Resultatsider' : _ref$ariaLabel,
      props = troika_react_pagination_dist_index_es_objectWithoutPropertiesLoose(_ref, ["children", "className", "currentPage", "lastPage", "aria-labelledby", "aria-label"]);

  if (!Number.isInteger(currentPage)) {
    throw new TypeError("Invalid currentPage: " + JSON.stringify(currentPage));
  }

  if (!Number.isInteger(lastPage)) {
    throw new TypeError("Invalid lastPage: " + JSON.stringify(lastPage));
  }

  var context = (0,react.useMemo)(function () {
    return {
      currentPage: Math.max(1, Math.min(currentPage, lastPage)),
      lastPage: Math.max(1, lastPage)
    };
  }, [currentPage, lastPage]);
  return /*#__PURE__*/(0,react.createElement)("nav", troika_react_pagination_dist_index_es_extends({}, props, {
    className: troika_react_pagination_node_modules_classnames_default()('pagination', className),
    "aria-labelledby": ariaLabelledBy,
    ref: ref
  }), /*#__PURE__*/(0,react.createElement)("h1", {
    className: "u-screen-reader-only",
    id: ariaLabelledBy
  }, ariaLabel), /*#__PURE__*/(0,react.createElement)(PaginationContext.Provider, {
    value: context
  }, children));
});
PaginationContainer.displayName = "PaginationContainer";

var CurrentPage = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      className = _ref.className,
      props = troika_react_pagination_dist_index_es_objectWithoutPropertiesLoose(_ref, ["children", "className"]);

  var _usePagination = usePagination(),
      currentPage = _usePagination.currentPage;

  if (currentPage <= 1) {
    return null;
  }

  return /*#__PURE__*/(0,react.createElement)("div", troika_react_pagination_dist_index_es_extends({}, props, {
    className: troika_react_pagination_node_modules_classnames_default()('u-hide-gt768 u-pa8', className),
    ref: ref
  }), children || "Side " + currentPage);
});
CurrentPage.displayName = "CurrentPage";

var FirstPage = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var className = _ref.className,
      props = troika_react_pagination_dist_index_es_objectWithoutPropertiesLoose(_ref, ["className"]);

  var _usePagination = usePagination(),
      currentPage = _usePagination.currentPage;

  if (currentPage <= 2) {
    return null;
  }

  return /*#__PURE__*/(0,react.createElement)("a", troika_react_pagination_dist_index_es_extends({
    "aria-label": "F\xF8rste resultatside"
  }, props, {
    ref: ref,
    className: troika_react_pagination_node_modules_classnames_default()('button button--pill icon icon--pagination-first u-mr32', className),
    rel: "start"
  }));
});
FirstPage.displayName = "FirstPage";

var _ref2 = /*#__PURE__*/(0,react.createElement)("span", {
  className: "icon icon--chevron-right"
});

var NextPage = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var _ref$children = _ref.children,
      children = _ref$children === void 0 ? 'Neste' : _ref$children,
      className = _ref.className,
      props = troika_react_pagination_dist_index_es_objectWithoutPropertiesLoose(_ref, ["children", "className"]);

  var _usePagination = usePagination(),
      currentPage = _usePagination.currentPage,
      lastPage = _usePagination.lastPage;

  if (currentPage >= lastPage) {
    return null;
  }

  return /*#__PURE__*/(0,react.createElement)("a", troika_react_pagination_dist_index_es_extends({
    "aria-label": "Neste resultatside"
  }, props, {
    ref: ref,
    rel: "next nofollow",
    className: troika_react_pagination_node_modules_classnames_default()('button button--pill button--has-icon button--icon-right', className)
  }), _ref2, currentPage <= 1 && /*#__PURE__*/(0,react.createElement)("span", {
    className: "button__text u-hide-gt768"
  }, children));
});
NextPage.displayName = "NextPage";

var Page = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var _ref$page = _ref.page,
      page = _ref$page === void 0 ? 0 : _ref$page,
      className = _ref.className,
      currentPage = _ref.currentPage,
      props = troika_react_pagination_dist_index_es_objectWithoutPropertiesLoose(_ref, ["page", "className", "currentPage"]);

  if (page < 1) {
    return null;
  }

  return /*#__PURE__*/(0,react.createElement)("a", troika_react_pagination_dist_index_es_extends({
    "aria-label": "Side " + page
  }, props, {
    ref: ref,
    rel: "nofollow",
    "aria-current": page === currentPage ? 'page' : undefined,
    className: troika_react_pagination_node_modules_classnames_default()('pagination__page button button--pill', className)
  }), page);
});
Page.displayName = "Page";

var Pages = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      className = _ref.className,
      props = troika_react_pagination_dist_index_es_objectWithoutPropertiesLoose(_ref, ["children", "className"]);

  var _usePagination = usePagination(),
      currentPage = _usePagination.currentPage,
      lastPage = _usePagination.lastPage;

  var from = Math.max(currentPage - 3, 0);
  var to = Math.min(from + 7, lastPage);
  var pages = Array.from(Array(to - from).keys()).map(function (_, i) {
    return from + i + 1;
  });
  return /*#__PURE__*/(0,react.createElement)("div", troika_react_pagination_dist_index_es_extends({}, props, {
    className: troika_react_pagination_node_modules_classnames_default()('u-hide-lt768', className),
    ref: ref
  }), pages.map(function (page) {
    return /*#__PURE__*/(0,react.cloneElement)(children(page), {
      key: page,
      page: page,
      currentPage: currentPage
    });
  }));
});
Pages.displayName = "Pages";

var PrevPage = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var className = _ref.className,
      props = troika_react_pagination_dist_index_es_objectWithoutPropertiesLoose(_ref, ["className"]);

  var _usePagination = usePagination(),
      currentPage = _usePagination.currentPage;

  if (currentPage <= 1) {
    return null;
  }

  return /*#__PURE__*/(0,react.createElement)("a", troika_react_pagination_dist_index_es_extends({
    "aria-label": "Forrige resultatside"
  }, props, {
    ref: ref,
    className: troika_react_pagination_node_modules_classnames_default()('button button--pill icon icon--chevron-left', className),
    rel: "prev nofollow"
  }));
});
PrevPage.displayName = "PrevPage";

var _ref2$1 = /*#__PURE__*/(0,react.createElement)(CurrentPage, null);

var Pagination = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var currentPage = _ref.currentPage,
      lastPage = _ref.lastPage,
      createHref = _ref.createHref,
      className = _ref.className,
      onChange = _ref.onChange,
      props = troika_react_pagination_dist_index_es_objectWithoutPropertiesLoose(_ref, ["currentPage", "lastPage", "createHref", "className", "onChange"]);

  if (!createHref) {
    throw new TypeError('createHref is undefined');
  }

  var handleClick = function handleClick(page) {
    return function (event) {
      if (onChange) {
        event.preventDefault();
        onChange(page);
      }
    };
  };

  return /*#__PURE__*/(0,react.createElement)(PaginationContainer, troika_react_pagination_dist_index_es_extends({}, props, {
    ref: ref,
    currentPage: currentPage,
    lastPage: lastPage,
    className: className
  }), /*#__PURE__*/(0,react.createElement)(FirstPage, {
    href: createHref(1),
    onClick: handleClick(1)
  }), /*#__PURE__*/(0,react.createElement)(PrevPage, {
    href: createHref(currentPage - 1),
    onClick: handleClick(currentPage - 1)
  }), /*#__PURE__*/(0,react.createElement)(Pages, null, function (page) {
    return /*#__PURE__*/(0,react.createElement)(Page, {
      href: createHref(page),
      onClick: handleClick(page)
    });
  }), _ref2$1, /*#__PURE__*/(0,react.createElement)(NextPage, {
    href: createHref(currentPage + 1),
    onClick: handleClick(currentPage + 1)
  }));
});
Pagination.displayName = "Pagination";


//# sourceMappingURL=index.es.js.map

// EXTERNAL MODULE: ../../node_modules/@finn-no/troika-react-textfield/node_modules/classnames/index.js
var troika_react_textfield_node_modules_classnames = __webpack_require__(3285);
var troika_react_textfield_node_modules_classnames_default = /*#__PURE__*/__webpack_require__.n(troika_react_textfield_node_modules_classnames);
// EXTERNAL MODULE: ../../node_modules/@finn-no/troika-react-utils/dist/index.es.js + 1 modules
var troika_react_utils_dist_index_es = __webpack_require__(6991);
;// CONCATENATED MODULE: ../../node_modules/@finn-no/troika-react-textfield/node_modules/@finn-no/troika-react-input/dist/index.es.js




function troika_react_input_dist_index_es_extends() {
  troika_react_input_dist_index_es_extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return troika_react_input_dist_index_es_extends.apply(this, arguments);
}

function troika_react_input_dist_index_es_objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/**
 * Groups together and affect the styling of labels, controls and helptext.
 */
var Field = function Field(_ref) {
  var className = _ref.className,
      isDisabled = _ref.isDisabled,
      isInvalid = _ref.isInvalid,
      isReadOnly = _ref.isReadOnly,
      props = troika_react_input_dist_index_es_objectWithoutPropertiesLoose(_ref, ["className", "isDisabled", "isInvalid", "isReadOnly"]);

  return /*#__PURE__*/react.createElement("div", troika_react_input_dist_index_es_extends({
    className: troika_react_textfield_node_modules_classnames_default()('input input--no-bottom-margin', {
      'input--is-invalid': isInvalid,
      'input--is-disabled': isDisabled,
      'input--is-read-only': isReadOnly
    }, className)
  }, props));
};

Field.displayName = "Field";

/**
 * Use together with a form component to give additional context if the label
 * or placeholder isn't enough. It is also used for error messages.
 * Should be used inside a `<Field>` component.
 *
 * To be accessible, give this component an `id` and connect the form input to the helptext using `aria-describedby`.
 */
var HelpText = function HelpText(_ref) {
  var className = _ref.className,
      props = troika_react_input_dist_index_es_objectWithoutPropertiesLoose(_ref, ["className"]);

  return /*#__PURE__*/react.createElement("div", troika_react_input_dist_index_es_extends({
    className: troika_react_textfield_node_modules_classnames_default()('input__sub-text', className)
  }, props));
};

HelpText.displayName = "HelpText";

/**
 * Use the Label component to connect a label with a form component in an accessible way.
 */
var Label = function Label(_ref) {
  var className = _ref.className,
      props = troika_react_input_dist_index_es_objectWithoutPropertiesLoose(_ref, ["className"]);

  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/label-has-for
    react.createElement("label", troika_react_input_dist_index_es_extends({
      className: troika_react_textfield_node_modules_classnames_default()('label', className)
    }, props))
  );
};

Label.displayName = "Label";

/**
 *
 * @param options.id The id of the field's control. Used as a base for the id of other elements. Generated automatically if not provided.
 * @param options.hasError If the form control is in an error/invalid state
 * @param options.hasHelpText If the form control has any help text
 */

function useField(options) {
  var id = (0,troika_react_utils_dist_index_es/* useId */.Me)(options.id);
  var helpTextId = "help__" + id;
  var helpTextProps = {
    id: helpTextId,
    // if the field is invalid/ in an error state, the helptext should have the `alert` role
    role: options.hasError ? 'alert' : undefined
  };
  var controlProps = {
    id: id,
    'aria-describedby': options.hasHelpText ? helpTextId : undefined,
    'aria-invalid': options.hasError,
    'aria-errormessage': options.hasError && options.hasHelpText ? helpTextId : undefined
  };
  return {
    controlProps: controlProps,
    helpTextProps: helpTextProps
  };
}


//# sourceMappingURL=index.es.js.map

;// CONCATENATED MODULE: ../../node_modules/@finn-no/troika-react-textfield/dist/index.es.js





function troika_react_textfield_dist_index_es_extends() {
  troika_react_textfield_dist_index_es_extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return troika_react_textfield_dist_index_es_extends.apply(this, arguments);
}

function troika_react_textfield_dist_index_es_objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var SearchButton = function SearchButton(_ref) {
  var _ref$ariaLabel = _ref['aria-label'],
      ariaLabel = _ref$ariaLabel === void 0 ? 'Nullstill' : _ref$ariaLabel,
      className = _ref.className,
      props = troika_react_textfield_dist_index_es_objectWithoutPropertiesLoose(_ref, ["aria-label", "className"]);

  return /*#__PURE__*/react.createElement("button", troika_react_textfield_dist_index_es_extends({
    "aria-label": ariaLabel,
    className: troika_react_textfield_node_modules_classnames_default()('input--search__button input--search__button--reset', className)
  }, props));
};

SearchButton.displayName = "SearchButton";

var SearchButton$1 = function SearchButton(_ref) {
  var _ref$ariaLabel = _ref['aria-label'],
      ariaLabel = _ref$ariaLabel === void 0 ? 'Søk' : _ref$ariaLabel,
      className = _ref.className,
      props = troika_react_textfield_dist_index_es_objectWithoutPropertiesLoose(_ref, ["aria-label", "className"]);

  return /*#__PURE__*/react.createElement("button", troika_react_textfield_dist_index_es_extends({
    "aria-label": ariaLabel,
    className: troika_react_textfield_node_modules_classnames_default()('input--search__button input--search__button--submit', className)
  }, props));
};

SearchButton$1.displayName = "SearchButton";

var TextField = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var appendAddon = _ref.appendAddon,
      className = _ref.className,
      disabled = _ref.disabled,
      id = _ref.id,
      error = _ref.error,
      label = _ref.label,
      helpText = _ref.helpText,
      readOnly = _ref.readOnly,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'text' : _ref$type,
      style = _ref.style,
      props = troika_react_textfield_dist_index_es_objectWithoutPropertiesLoose(_ref, ["appendAddon", "className", "disabled", "id", "error", "label", "helpText", "readOnly", "type", "style"]);

  if (false) { var shouldWarn; }

  var _useField = useField({
    id: id,
    hasError: error,
    hasHelpText: Boolean(helpText)
  }),
      controlProps = _useField.controlProps,
      helpTextProps = _useField.helpTextProps;

  return /*#__PURE__*/(0,react.createElement)(Field, {
    className: troika_react_textfield_node_modules_classnames_default()("input--" + type, className),
    isDisabled: disabled,
    isInvalid: error,
    isReadOnly: readOnly,
    style: style
  }, /*#__PURE__*/(0,react.createElement)(Label, {
    htmlFor: controlProps.id
  }, label), /*#__PURE__*/(0,react.createElement)("input", troika_react_textfield_dist_index_es_extends({}, controlProps, {
    disabled: disabled,
    readOnly: readOnly,
    ref: ref,
    type: type
  }, props)), appendAddon, helpText && /*#__PURE__*/(0,react.createElement)(HelpText, helpTextProps, helpText));
});
TextField.displayName = "TextField";


//# sourceMappingURL=index.es.js.map

;// CONCATENATED MODULE: ../../node_modules/@finn-no/favorite-heart-component/dist/index.esm.js














function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function index_esm_extends() {
  index_esm_extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return index_esm_extends.apply(this, arguments);
}

function index_esm_objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = index_esm_objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var classes = {"modal":"App-module_modal__3YxbT","numFavs":"App-module_numFavs__1deXr","troikaBlue":"App-module_troikaBlue__1O3y_","iconHeartActive":"App-module_iconHeartActive__25Ds6","iconHeartNeutral":"App-module_iconHeartNeutral__ohHay","iconHeartBlueActive":"App-module_iconHeartBlueActive__2Du0i","iconHeartBlueNeutral":"App-module_iconHeartBlueNeutral__JafxO","imageHeartActive":"App-module_imageHeartActive__n0P48","imageHeartNeutral":"App-module_imageHeartNeutral__EWkep","login":"App-module_login__VoVCz","backButton":"App-module_backButton__2CBZ3","grid":"App-module_grid__p5O4H","label":"App-module_label__2HCmI","folderIcon":"App-module_folderIcon__Bestp","folderGiftIcon":"App-module_folderGiftIcon__3snBk","folderGiftIconChecked":"App-module_folderGiftIconChecked__3lIw4","folderIconChecked":"App-module_folderIconChecked__1YdYT","plusButton":"App-module_plusButton__1NLy-","plus":"App-module_plus__uVUxO","image":"App-module_image__1Ma_7","imageUnchecked":"App-module_imageUnchecked__2fFs0","imageChecked":"App-module_imageChecked__T3sJy","imageSpinner":"App-module_imageSpinner__VCMjq","save-ad-rotation":"App-module_save-ad-rotation__33g8V","listButton":"App-module_listButton__1vOk6","modalHeader":"App-module_modalHeader__1qFrS","modalFooter":"App-module_modalFooter__1w3PQ"};

var HeartButton = /*#__PURE__*/(0,react.forwardRef)((props, forwardRef) => {
  var {
    className: externalClassname,
    onClick,
    toggled,
    variant,
    numFavs
  } = props;
  var label = toggled ? 'Lagt som favoritt' : 'Legg til favoritt';
  var className = classnames_default()('button', externalClassname, {
    'button--pill icon': variant === 'heart' || variant === 'heart-blue' || variant === 'heart-on-image',
    [classes.iconHeartBlueActive]: variant === 'heart-blue' && toggled,
    [classes.iconHeartBlueNeutral]: variant === 'heart-blue' && !toggled,
    [classes.iconHeartActive]: variant === 'heart' && toggled,
    [classes.iconHeartNeutral]: variant === 'heart' && !toggled,
    [classes.imageHeartActive]: variant === 'heart-on-image' && toggled,
    [classes.imageHeartNeutral]: variant === 'heart-on-image' && !toggled,
    'button--has-icon': variant === 'button',
    'u-ph16': variant === 'button' && !toggled,
    'u-ph8': variant === 'button' && toggled
  });
  var button = /*#__PURE__*/react.createElement("button", {
    "aria-haspopup": "dialog",
    "aria-label": "Hjertemerke",
    "aria-pressed": toggled,
    className: className,
    onClick: onClick,
    ref: forwardRef,
    title: variant === 'heart' || variant === 'heart-blue' || variant === 'heart-on-image' ? label : undefined
  }, variant === 'button' && /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("span", {
    className: classnames_default()('icon', {
      [classes.iconHeartBlueActive]: toggled,
      [classes.iconHeartBlueNeutral]: !toggled
    })
  }), label));

  if (numFavs > 0) {
    return /*#__PURE__*/react.createElement("div", {
      className: classes.numFavs
    }, button, /*#__PURE__*/react.createElement("div", {
      className: "u-d1 u-text-left u-pt2 u-licorice"
    }, numFavs, " har lagt til som favoritt"));
  }

  return button;
});

var ChristmasGiftContext = /*#__PURE__*/react.createContext(false);
function useChristmasGift() {
  return react.useContext(ChristmasGiftContext);
}
var {
  Provider
} = ChristmasGiftContext;

var index_esm_usePagination = _ref => {
  var {
    pageSize,
    folders,
    searchQuery,
    specialButtons
  } = _ref;
  var [currentPage, setCurrentPage] = (0,react.useState)(1);
  var pagination = (0,react.useMemo)(() => {
    // The `+ ${specialButtons}` is because we're prepending special button(s) to the list
    var totalPages = Math.ceil((folders.length + specialButtons) / pageSize); // calculate start and end item indexes with logic to handle the "Ny liste" insertion

    var startIndex = (currentPage - 1) * pageSize - (currentPage > 1 ? specialButtons : 0);
    var endIndex = Math.min(currentPage * pageSize - 1 - specialButtons, folders.length - 1);
    return {
      totalPages,
      startIndex,
      endIndex
    };
  }, [currentPage, folders.length, pageSize, specialButtons]);
  var paginatedFolders = (0,react.useMemo)(() => folders.filter((_, index) => index >= pagination.startIndex && index <= pagination.endIndex), [folders, pagination.endIndex, pagination.startIndex]); // If a search query happened or the list changed length we need to reset the pagination

  (0,react.useEffect)(() => {
    if (searchQuery || folders.length) {
      setCurrentPage(1);
    }
  }, [searchQuery, folders.length]);
  return {
    pagination,
    paginatedFolders,
    currentPage,
    setCurrentPage
  };
};

var useSearch = _ref => {
  var {
    items
  } = _ref;
  var [searchQuery, setSearchQuery] = (0,react.useState)('');
  var filteredFavoriteLists = (0,react.useMemo)(() => {
    var query = searchQuery.toLowerCase();
    return query ? items.filter(fl => fl.name.toLowerCase().includes(query)) : items;
  }, [items, searchQuery]);
  (0,react.useEffect)(() => {
    if (searchQuery) {
      // Track searches
      client["default"].trackEvent({
        analyticsName: 'navigation.favorite-search-by-keyword',
        eventFlags: 'success',
        stringValue: 'modal',
        eventData: {
          numberOfLists: items.length.toString()
        }
      });
    }
  }, [items.length, searchQuery]);
  return {
    searchQuery,
    setSearchQuery,
    filteredFavoriteLists
  };
};

var index_esm_Pagination = props => {
  var {
    currentPage,
    totalPages = 0,
    setCurrentPage
  } = props;

  if (!totalPages || totalPages <= 1) {
    return null;
  }

  return /*#__PURE__*/react.createElement(PaginationContainer, {
    currentPage: currentPage,
    lastPage: totalPages,
    className: "u-pt8 u-pb2"
  }, /*#__PURE__*/react.createElement(PrevPage, {
    href: "#",
    onClick: event => {
      event.preventDefault();
      var pulsePayload = {
        object: {
          type: "Listing",
          layout: "List",
          pageNumber: currentPage - 1
        }
      };
      client_min_default().trackPageView(pulsePayload);
      client["default"].trackEvent({
        analyticsName: "collect.add-favorite.pagination"
      });
      setCurrentPage(currentPage - 1);
    }
  }), /*#__PURE__*/react.createElement(Pages, null, page => /*#__PURE__*/react.createElement(Page, {
    href: "#",
    onClick: event => {
      event.preventDefault();
      var pulsePayload = {
        object: {
          type: "Listing",
          layout: "List",
          pageNumber: page
        }
      };
      client_min_default().trackPageView(pulsePayload);
      client["default"].trackEvent({
        analyticsName: "collect.add-favorite.pagination"
      });
      setCurrentPage(page);
    }
  })), /*#__PURE__*/react.createElement(CurrentPage, null), /*#__PURE__*/react.createElement(NextPage, {
    href: "#",
    onClick: event => {
      event.preventDefault();
      var pulsePayload = {
        object: {
          type: "Listing",
          layout: "List",
          pageNumber: currentPage + 1
        }
      };
      client_min_default().trackPageView(pulsePayload);
      client["default"].trackEvent({
        analyticsName: "collect.add-favorite.pagination"
      });
      setCurrentPage(currentPage + 1);
    }
  }));
};

var Search = _ref => {
  var {
    onSearch,
    initialFocusRef
  } = _ref;
  return /*#__PURE__*/react.createElement(TextField, {
    ref: initialFocusRef,
    label: "S\xF8k etter en liste",
    type: "search",
    placeholder: "Navn p\xE5 en liste",
    appendAddon: /*#__PURE__*/react.createElement(SearchButton$1, null),
    onChange: event => onSearch(event.target.value)
  });
};

var christmasGiftListName = 'Mine julegaveønsker';

function dummyToast(message, _ref) {
  var {
    type
  } = _ref;
  console.log("toast ".concat(type, ": ").concat(message));
}

function useToast() {
  var [toastModule, setToastModule] = (0,react.useState)({
    toast: dummyToast
  });

  function importToast() {
    return _importToast.apply(this, arguments);
  }

  function _importToast() {
    _importToast = _asyncToGenerator(function* () {
      var {
        toast
      } = yield __webpack_require__.e(/* import() */ 242).then(__webpack_require__.bind(__webpack_require__, 6242));
      setToastModule({
        toast
      });
    });
    return _importToast.apply(this, arguments);
  }

  (0,react.useEffect)(() => {
    importToast();
  }, []);
  return toastModule.toast;
}

var FolderButton = /*#__PURE__*/(0,react.forwardRef)((props, forwardRef) => {
  var {
    adExists,
    itemType,
    itemId,
    api,
    closeCallback,
    folder,
    handleError
  } = props;
  var [spinner, setSpinner] = (0,react.useState)(false);
  var toast = useToast();

  function handleToggleFavorite() {
    return _handleToggleFavorite.apply(this, arguments);
  }

  function _handleToggleFavorite() {
    _handleToggleFavorite = _asyncToGenerator(function* () {
      // clear out any potential error messages, if none exists then it's a no-op
      handleError('');
      setSpinner(true);
      adExists ? yield unFavorite() : yield addFavorite();
    });
    return _handleToggleFavorite.apply(this, arguments);
  }

  function addFavorite() {
    return _addFavorite.apply(this, arguments);
  }

  function _addFavorite() {
    _addFavorite = _asyncToGenerator(function* () {
      try {
        yield api.addToFolder(itemType, itemId, folder.folderid);
        var pulsePayload = {
          type: 'Click',
          intent: 'Save',
          name: 'New favorite',
          object: {
            id: "favoritelist:".concat(folder.folderid),
            type: 'UIElement',
            elementType: 'Popup',
            name: 'Favorite List',
            items: [{
              type: 'ClassifiedAd',
              id: itemType === 'Hotel' ? "hotel:".concat(itemId) : "".concat(itemId),
              contentId: "".concat(itemId),
              name: 'n/a',
              category: 'n/a'
            }]
          },
          target: {
            id: itemType === 'Hotel' ? "classified:hotel:".concat(itemId) : "classified:".concat(itemId),
            type: 'SavedList',
            name: folder.name === 'Mine julegaveønsker' ? 'Christmas list' : 'Favorite list'
          }
        };
        client_min_default().trackEvent(pulsePayload);
        client["default"].trackEvent({
          analyticsName: 'collect.add-favorite.done',
          eventFlags: 'success'
        }); // @ts-expect-error legacy EC tracking for statistics and recommendations (and more?)

        client["default"].trackEvent({
          ecType: 'AD',
          ecCategory: 'NoOfSeenByFolderMembers',
          eventData: {
            'ad.id': itemId.toString(),
            'ad.type': itemType.toString()
          }
        });
        closeCallback();
        toast("Favoritten ble lagt til i ".concat(folder.name), {
          type: 'success'
        });
      } catch (error) {
        console.error(error);
        setSpinner(false);
        handleError('Kunne ikke legge til favoritten. Prøv på nytt senere.');
      }
    });
    return _addFavorite.apply(this, arguments);
  }

  function unFavorite() {
    return _unFavorite.apply(this, arguments);
  }

  function _unFavorite() {
    _unFavorite = _asyncToGenerator(function* () {
      try {
        yield api.removeFromFolder(itemType, itemId, folder.folderid);
        var pulsePayload = {
          type: 'Click',
          intent: 'Edit',
          name: 'New favorite',
          object: {
            id: "favoritelist:".concat(folder.folderid),
            type: 'UIElement',
            elementType: 'Button',
            name: 'Favorite List',
            items: [{
              type: 'ClassifiedAd',
              id: itemType === 'Hotel' ? "hotel:".concat(itemId) : "".concat(itemId),
              contentId: "".concat(itemId),
              name: 'n/a',
              category: 'n/a'
            }]
          },
          target: {
            id: itemType === 'Hotel' ? "classified:hotel:".concat(itemId) : "classified:".concat(itemId),
            type: 'FavoriteItem',
            name: 'Classified Ad'
          }
        };
        client_min_default().trackEvent(pulsePayload);
        client["default"].trackEvent({
          analyticsName: 'collect.remove-favorite.done',
          eventFlags: 'success'
        });
        closeCallback();
        toast("Fjernet favoritten fra ".concat(folder.name), {
          type: 'success'
        });
      } catch (error) {
        console.error(error);
        setSpinner(false);
        handleError('Kunne ikke fjerne favoritten. Prøv på nytt senere.');
      }
    });
    return _unFavorite.apply(this, arguments);
  }

  var classList = [classes.image];

  if (adExists) {
    if (folder.name === christmasGiftListName) {
      classList.push(classes.folderGiftIconChecked);
    } else if (!folder.image) {
      classList.push(classes.folderIconChecked);
    } else {
      classList.push(classes.imageChecked);
    }
  } else {
    if (folder.name === christmasGiftListName) {
      classList.push(classes.folderGiftIcon);
    } else if (!folder.image) {
      classList.push(classes.folderIcon);
    } else {
      classList.push(classes.imageUnchecked);
    }
  }

  if (spinner) {
    classList.push(classes.imageSpinner);
  }

  var image = "url(".concat(folder.image, ")");
  return /*#__PURE__*/react.createElement("button", {
    className: classnames_default()(classes.listButton),
    onClick: handleToggleFavorite,
    "aria-pressed": adExists,
    ref: forwardRef
  }, /*#__PURE__*/react.createElement("span", {
    className: classnames_default()(classList),
    style: {
      ['--image-url']: image
    }
  }), /*#__PURE__*/react.createElement("span", {
    className: classes.label
  }, folder.name));
});

var NewListButton = /*#__PURE__*/(0,react.forwardRef)((_ref, forwardRef) => {
  var {
    onClick,
    variant
  } = _ref;
  return /*#__PURE__*/react.createElement("button", {
    className: classes.listButton,
    onClick: onClick,
    ref: forwardRef
  }, variant === 'gift' ? /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("span", {
    className: classnames_default()(classes.plusButton, classes.folderGiftIcon)
  }), /*#__PURE__*/react.createElement("span", {
    className: classnames_default()(classes.label)
  }, "Lag ny \xF8nskeliste")) : /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("span", {
    className: classnames_default()(classes.plusButton, classes.plus)
  }), /*#__PURE__*/react.createElement("span", {
    className: classnames_default()(classes.label)
  }, "Lag ny liste")));
});

var useCreateList = _ref => {
  var {
    api,
    itemType,
    itemId,
    setErrorMessage,
    closeCallback
  } = _ref;
  var submittingRef = (0,react.useRef)(false);
  var toast = useToast();
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(function* (folderName, extraFlags) {
      // Just ignore additional submit events while processing the current request
      if (submittingRef.current) return;
      submittingRef.current = true;

      try {
        var res = yield api.createFolder(folderName);

        if (res.status === 409) {
          var x = yield res.json();
          throw x;
        }

        if (!res.ok) {
          throw res;
        }

        var {
          folderid: folderId
        } = yield res.json();
        var pulsePayload = {
          type: 'Click',
          intent: 'Create',
          name: 'New favorite list',
          object: {
            type: 'UIElement',
            id: "favoritelist:".concat(folderId),
            elementType: 'Popup'
          },
          target: {
            id: "favoritelist:".concat(folderId),
            type: 'SavedList',
            name: folderName === 'Mine julegaveønsker' ? 'Christmas list' : 'Favorite list'
          }
        };
        client_min_default().trackEvent(pulsePayload);
        client["default"].trackEvent({
          analyticsName: 'collect.create-favorite-list',
          eventFlags: 'success',
          stringValue: extraFlags
        });

        try {
          yield api.addToFolder(itemType, itemId, folderId);
          toast("Favoritten ble lagt til i ".concat(folderName), {
            type: 'success'
          });
          var _pulsePayload = {
            type: 'Click',
            intent: 'Save',
            name: 'New favorite',
            object: {
              id: "favoritelist:".concat(folderId),
              type: 'UIElement',
              elementType: 'Popup',
              name: 'Favorite List',
              items: [{
                type: 'ClassifiedAd',
                id: itemType === 'Hotel' ? "hotel:".concat(itemId) : "".concat(itemId),
                contentId: "".concat(itemId),
                name: 'n/a',
                category: 'n/a'
              }]
            },
            target: {
              id: itemType === 'Hotel' ? "classified:hotel:".concat(itemId) : "classified:".concat(itemId),
              type: 'SavedList',
              name: folderName === 'Mine julegaveønsker' ? 'Mine julegaveønsker' : 'Favorite list'
            }
          };
          client_min_default().trackEvent(_pulsePayload);
          client["default"].trackEvent({
            analyticsName: 'collect.add-favorite.done',
            eventFlags: 'success'
          });
        } catch (error) {
          console.error(error);
          submittingRef.current = false;
          toast('Kunne ikke legge til favoritten. Prøv på nytt senere.', {
            type: 'error'
          });
        } finally {
          closeCallback();
        }
      } catch (error) {
        console.error(error);
        submittingRef.current = false;

        try {
          if (!error.title) {
            throw new TypeError();
          }

          setErrorMessage(error.title);
        } catch (error) {
          console.error(error);
          setErrorMessage('Usjda, kunne ikke lagre listen');
        }
      }
    });

    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};

var FoldersTemplate = /*#__PURE__*/(0,react.forwardRef)((props, forwardRef) => {
  var {
    itemType,
    itemId,
    api,
    closeCallback,
    folders,
    foldersWithItem,
    setErrorMessage,
    toggleCreateNewFolder
  } = props;
  var createList = useCreateList({
    api,
    itemType,
    itemId,
    setErrorMessage,
    closeCallback
  });
  var christmasGiftList = useChristmasGift(); // This CSS class mitigates a known style conflict between Troika and Fabric, as described
  // here https://github.schibsted.io/finn/fabric/blob/master/README.md#the-grid-class
  // The class can be removed once this component has been migrated to Fabric.

  var fabricOverrideClassName = 't-grid';
  return /*#__PURE__*/react.createElement("div", {
    className: "".concat(classes.grid, " grid ").concat(fabricOverrideClassName, " grid--cols3upto640 grid--cols4upto990 grid--cols4from990")
  }, toggleCreateNewFolder && /*#__PURE__*/react.createElement("div", {
    key: "new-list",
    className: "grid__unit"
  }, /*#__PURE__*/react.createElement(NewListButton, {
    ref: forwardRef,
    onClick: toggleCreateNewFolder,
    variant: "default"
  })), christmasGiftList && toggleCreateNewFolder && !folders.some(f => f.name === christmasGiftListName) && /*#__PURE__*/react.createElement("div", {
    key: "new-gift-list",
    className: "grid__unit"
  }, /*#__PURE__*/react.createElement(NewListButton, {
    ref: forwardRef,
    onClick: () => createList(christmasGiftListName, 'christmaslist'),
    variant: "gift"
  })), folders.map((fl, index) => /*#__PURE__*/react.createElement("div", {
    key: fl.folderid,
    className: "grid__unit"
  }, /*#__PURE__*/react.createElement(FolderButton, {
    ref: !toggleCreateNewFolder && index === 0 ? forwardRef : undefined,
    adExists: !!foldersWithItem.folderIds && foldersWithItem.folderIds.includes(fl.folderid),
    itemType: itemType,
    itemId: itemId,
    api: api,
    closeCallback: closeCallback,
    folder: fl,
    handleError: message => setErrorMessage(message),
    key: fl.folderid
  }))));
});
var BottomSheetToolbar$1 = _ref => {
  var {
    onDismiss
  } = _ref;
  return /*#__PURE__*/react.createElement(index_es/* BottomSheetToolbar */.a, {
    title: "Velg liste",
    right: /*#__PURE__*/react.createElement(FlatButton, {
      className: "u-pa0",
      onClick: onDismiss
    }, "Lukk")
  });
};
var BottomSheetContent$1 = props => {
  var {
    itemType,
    itemId,
    api,
    closeCallback,
    errorMessage,
    foldersWithItem,
    items,
    setErrorMessage,
    toggleCreateNewFolder,
    initialFocusRef
  } = props;
  var {
    filteredFavoriteLists,
    searchQuery,
    setSearchQuery
  } = useSearch({
    items
  });
  return /*#__PURE__*/react.createElement(troika_react_panel_dist_index_es, null, /*#__PURE__*/react.createElement(Search, {
    onSearch: searchQuery => setSearchQuery(searchQuery),
    initialFocusRef: initialFocusRef
  }), errorMessage && /*#__PURE__*/react.createElement("div", {
    className: "u-cherry u-mv16",
    role: "alert"
  }, errorMessage), searchQuery && filteredFavoriteLists.length < 1 && /*#__PURE__*/react.createElement("p", {
    className: "u-pv32 u-ph8 u-text-center u-t4"
  }, "Fant ingen lister som svarer til s\xF8ket ditt :("), /*#__PURE__*/react.createElement(FoldersTemplate, {
    itemType: itemType,
    itemId: itemId,
    api: api,
    closeCallback: closeCallback,
    toggleCreateNewFolder: searchQuery ? undefined : toggleCreateNewFolder,
    foldersWithItem: foldersWithItem,
    setErrorMessage: setErrorMessage,
    folders: filteredFavoriteLists
  }));
};
var ModalContent$1 = props => {
  var {
    itemType,
    itemId,
    api,
    closeCallback,
    errorMessage,
    foldersWithItem,
    items,
    setErrorMessage,
    toggleCreateNewFolder,
    initialFocusRef
  } = props;
  var {
    filteredFavoriteLists,
    searchQuery,
    setSearchQuery
  } = useSearch({
    items
  });
  var christmasGiftList = useChristmasGift();
  var numSpecialButtons = christmasGiftList && !filteredFavoriteLists.some(f => f.name === christmasGiftListName) ? 2 : 1;
  var {
    currentPage,
    paginatedFolders,
    pagination,
    setCurrentPage
  } = index_esm_usePagination({
    folders: filteredFavoriteLists,
    pageSize: 8,
    searchQuery,
    specialButtons: numSpecialButtons
  });
  var focusFirstItemRef = (0,react.useRef)(null);
  var [shouldFocusFirstItem, setShouldFocusFirstItem] = (0,react.useState)(false);
  var setCurrentPageAndFocusFirstItem = (0,react.useCallback)(page => {
    setCurrentPage(page);
    setShouldFocusFirstItem(true);
  }, [setCurrentPage]);
  (0,react.useEffect)(() => {
    if (shouldFocusFirstItem && currentPage >= 0 && focusFirstItemRef.current) {
      focusFirstItemRef.current.focus(); // Setting to false again to avoid the search input losing focus when typing

      setShouldFocusFirstItem(false);
    }
  }, [currentPage, shouldFocusFirstItem]);
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(ModalContent, null, /*#__PURE__*/react.createElement("div", {
    className: "u-mt16 ".concat(classes.modalHeader)
  }, /*#__PURE__*/react.createElement("h1", {
    className: "u-mt16 u-t3"
  }, "Velg liste"), /*#__PURE__*/react.createElement(Search, {
    onSearch: searchQuery => setSearchQuery(searchQuery),
    initialFocusRef: initialFocusRef
  })), searchQuery && filteredFavoriteLists.length < 1 && /*#__PURE__*/react.createElement("p", {
    className: "u-pv32 u-ph8 u-text-center u-t4"
  }, "Fant ingen lister som svarer til s\xF8ket ditt :("), errorMessage && /*#__PURE__*/react.createElement("div", {
    className: "u-cherry u-mv16",
    role: "alert"
  }, errorMessage), /*#__PURE__*/react.createElement(FoldersTemplate, {
    ref: focusFirstItemRef,
    itemType: itemType,
    itemId: itemId,
    api: api,
    closeCallback: closeCallback,
    folders: paginatedFolders,
    foldersWithItem: foldersWithItem,
    setErrorMessage: setErrorMessage,
    toggleCreateNewFolder: currentPage !== 1 || searchQuery ? undefined : toggleCreateNewFolder
  }), /*#__PURE__*/react.createElement(index_esm_Pagination, {
    currentPage: currentPage,
    setCurrentPage: setCurrentPageAndFocusFirstItem,
    totalPages: pagination.totalPages
  })), /*#__PURE__*/react.createElement(ModalFooter, {
    className: "u-pt16"
  }, /*#__PURE__*/react.createElement(Button, {
    onClick: closeCallback
  }, "Lukk")));
};

var promoteAdIdsInSortPure = (folderIds, favs) => {
  var favsComparator = folderIds => (a, b) => {
    if (a.default) {
      return -1;
    } else if (b.default) {
      return 1;
    } else if (folderIds.includes(a.folderid) && folderIds.includes(b.folderid)) {
      return 0;
    } else if (folderIds.includes(a.folderid)) {
      return -1;
    } else if (folderIds.includes(b.folderid)) {
      return 1;
    } else {
      return 0;
    }
  };

  if (folderIds) {
    var cmp = favsComparator(folderIds);
    return favs.sort(cmp);
  } else {
    return favs;
  }
};

var useFetchFolders = _ref => {
  var {
    api,
    itemType,
    itemId,
    userId
  } = _ref;
  var [items, setItems] = (0,react.useState)([]);
  var [foldersWithItem, setFoldersWithItem] = (0,react.useState)({
    itemType: itemType,
    itemId: itemId,
    folderIds: []
  });
  var [errorMessage, setErrorMessage] = (0,react.useState)('');
  (0,react.useEffect)(() => {
    var didCancel = false;

    function fetchFolders() {
      return _fetchFolders.apply(this, arguments);
    }

    function _fetchFolders() {
      _fetchFolders = _asyncToGenerator(function* () {
        try {
          var [_foldersWithItem, folders] = yield Promise.all([api.fetchFoldersForItem(itemType, itemId), api.fetchFolders().then(res => res.json())]);

          if (!didCancel) {
            setFoldersWithItem(_foldersWithItem);
            var sortedList = promoteAdIdsInSortPure(_foldersWithItem.folderIds, folders);
            setItems(sortedList);
          }
        } catch (error) {
          console.error(error);
          setErrorMessage(error.toString());
        }
      });
      return _fetchFolders.apply(this, arguments);
    }

    if (userId) {
      fetchFolders();
      return () => {
        didCancel = true;
      };
    }
  }, [itemType, itemId, api, userId]);
  return {
    items,
    errorMessage,
    foldersWithItem
  };
};

var useStartEventTracking = _ref => {
  var {
    toggled,
    userId,
    itemType,
    itemId
  } = _ref;
  (0,react.useEffect)(() => {
    if (userId) {
      var pulsePayload = {
        type: 'Click',
        intent: toggled ? 'Edit' : 'Create',
        name: 'New favorite',
        object: {
          id: itemType === 'Hotel' ? "classified:hotel:".concat(itemId) : "classified:".concat(itemId),
          type: 'UIElement',
          elementType: 'Button',
          items: [{
            type: 'ClassifiedAd',
            id: itemType === 'Hotel' ? "hotel:".concat(itemId) : "".concat(itemId),
            contentId: "".concat(itemId),
            name: 'n/a',
            category: 'n/a'
          }]
        },
        target: {
          id: itemType === 'Hotel' ? "classified:hotel:".concat(itemId) : "classified:".concat(itemId),
          type: 'FavoriteItem',
          name: 'Classified Ad'
        }
      };
      client_min_default().trackEvent(pulsePayload);
      client["default"].trackEvent({
        analyticsName: 'collect.add-favorite.start',
        stringValue: toggled ? 'filled' : 'empty'
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);
};

var LoginTemplate = _ref => {
  var {
    closeCallback,
    redirectUrl = window.location.href
  } = _ref;
  var setFocusRef = (0,react.useCallback)(element => {
    if (element !== null) {
      element.focus();
    }
  }, []);
  return /*#__PURE__*/react.createElement("div", {
    className: classes.login
  }, /*#__PURE__*/react.createElement("p", {
    className: "u-t4"
  }, "Logg inn"), /*#__PURE__*/react.createElement("p", null, "Logg inn for \xE5 legge annonsen i dine favorittlister. Da kan du lett  finne de igjen senere, uansett hvor du er."), /*#__PURE__*/react.createElement("div", {
    className: "u-text-right u-mt16"
  }, /*#__PURE__*/react.createElement(FlatButton, {
    className: "u-mr8",
    onClick: closeCallback
  }, "Ikke n\xE5"), /*#__PURE__*/react.createElement("a", {
    ref: setFocusRef,
    className: "button button--cta",
    href: "/loginForm.html?redirectTo=".concat(encodeURIComponent(redirectUrl)),
    onClick: () => client["default"].trackEventLater({
      analyticsName: 'user-admin.log-in.favourite-login',
      stringValue: 'modal-favorite-link'
    })
  }, "Logg inn")));
};

var BackButton = _ref => {
  var {
    onClick,
    className = 'u-pl0'
  } = _ref;
  return /*#__PURE__*/react.createElement(FlatButton, {
    className: classnames_default()('button--has-icon', classes.backButton, className),
    onClick: onClick
  }, "Tilbake");
};

var NewFolderTemplate = /*#__PURE__*/(0,react.forwardRef)((props, ref) => {
  var {
    itemType,
    itemId,
    api,
    closeCallback,
    initialFocusRef
  } = props;
  var [folderName, setFolderName] = (0,react.useState)('');
  var [errorMessage, setErrorMessage] = (0,react.useState)('');
  (0,react.useEffect)(() => {
    client["default"].trackEvent({
      analyticsName: 'collect.create-favorite-list',
      eventFlags: 'start'
    });
  }, []);
  var createList = useCreateList({
    api,
    itemType,
    itemId,
    setErrorMessage,
    closeCallback
  });

  function onSubmitFolder() {
    return _onSubmitFolder.apply(this, arguments);
  }

  function _onSubmitFolder() {
    _onSubmitFolder = _asyncToGenerator(function* () {
      if (!folderName.trim()) {
        if (initialFocusRef.current) {
          initialFocusRef.current.focus();
        }

        setShouldValidate(true);
        return;
      }

      return createList(folderName);
    });
    return _onSubmitFolder.apply(this, arguments);
  }

  (0,react.useImperativeHandle)(ref, () => ({
    submit: () => onSubmitFolder()
  })); // Validation feedback shouldn't be shown until after the user have interacted with the input

  var [shouldValidate, setShouldValidate] = (0,react.useState)(false);
  var inputField = /*#__PURE__*/react.createElement(TextField, {
    error: shouldValidate && folderName.trim().length < 1,
    helpText: "".concat(folderName.length, "/40 tegn"),
    label: "Gi listen et navn",
    maxLength: 40,
    onChange: event => setFolderName(event.target.value),
    ref: initialFocusRef,
    required: true,
    value: folderName
  });
  return /*#__PURE__*/react.createElement("form", {
    className: "u-pb8",
    onSubmit: event => {
      event.preventDefault();
      onSubmitFolder();
    }
  }, inputField, errorMessage && /*#__PURE__*/react.createElement("p", {
    className: "u-cherry",
    role: "alert"
  }, errorMessage));
});
var BottomSheetToolbar = props => {
  var {
    onCancel,
    onSubmit
  } = props;
  return /*#__PURE__*/react.createElement(index_es/* BottomSheetToolbar */.a, {
    left: /*#__PURE__*/react.createElement(BackButton, {
      className: "u-pa0",
      onClick: onCancel
    }),
    title: "Ny liste",
    right: /*#__PURE__*/react.createElement(FlatButton, {
      className: "u-pa0",
      onClick: onSubmit
    }, "Legg i liste")
  });
};
var BottomSheetContent = /*#__PURE__*/(0,react.forwardRef)((props, ref) => {
  var {
    itemType,
    itemId,
    api,
    initialFocusRef,
    closeCallback
  } = props;
  return /*#__PURE__*/react.createElement(troika_react_panel_dist_index_es, null, /*#__PURE__*/react.createElement(NewFolderTemplate, {
    itemType: itemType,
    itemId: itemId,
    api: api,
    initialFocusRef: initialFocusRef,
    closeCallback: closeCallback,
    ref: ref
  }));
});
var index_esm_ModalContent = /*#__PURE__*/(0,react.forwardRef)((props, ref) => {
  var {
    itemType,
    itemId,
    api,
    initialFocusRef,
    closeCallback,
    onCancel,
    onSubmit
  } = props;
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(ModalContent, null, /*#__PURE__*/react.createElement("h1", {
    className: "u-mv16 u-t3"
  }, "Ny liste"), /*#__PURE__*/react.createElement(NewFolderTemplate, {
    itemType: itemType,
    itemId: itemId,
    api: api,
    initialFocusRef: initialFocusRef,
    closeCallback: closeCallback,
    ref: ref
  })), /*#__PURE__*/react.createElement(ModalFooter, {
    className: classes.modalFooter
  }, /*#__PURE__*/react.createElement(BackButton, {
    onClick: onCancel
  }), /*#__PURE__*/react.createElement(CallToActionButton, {
    onClick: onSubmit
  }, "Legg i liste")));
});

var SaveAdBottomSheet = props => {
  var {
    itemType,
    itemId,
    api,
    isOpen,
    setOpen,
    redirectUrl,
    restoreFocus,
    toggled,
    userId
  } = props;
  useStartEventTracking({
    toggled,
    userId,
    itemType,
    itemId
  });
  var [createNewFolder, setCreateNewFolder] = (0,react.useState)(false);
  var toggleCreateNewFolder = (0,react.useCallback)(() => setCreateNewFolder(createNewFolder => !createNewFolder), []);
  var [errorMessage, setErrorMessage] = (0,react.useState)('');
  var {
    items,
    errorMessage: fetchFoldersErrorMessage,
    foldersWithItem
  } = useFetchFolders({
    api,
    itemType,
    itemId,
    userId
  });
  var newFolderFormRef = (0,react.useRef)(null);
  var FavoritesMoreOptionsFocusRef = (0,react.useRef)(null);
  var NewFolderTemplateFocusRef = (0,react.useRef)(null);
  var finalErrorMessage = errorMessage || fetchFoldersErrorMessage;
  var sharedProps = {
    open: isOpen,
    onSpringEnd: event => event.type === 'CLOSE' && setOpen(false),
    onDismiss: () => setOpen(false)
  };
  (0,react.useEffect)(() => {
    if (!isOpen) {
      restoreFocus();
    }
  }, [isOpen, restoreFocus]);

  if (userId) {
    if (createNewFolder) {
      return /*#__PURE__*/react.createElement(index_es/* BottomSheet */.R, index_esm_extends({}, sharedProps, {
        initialFocusRef: NewFolderTemplateFocusRef,
        header: /*#__PURE__*/react.createElement(BottomSheetToolbar, {
          onCancel: toggleCreateNewFolder,
          onSubmit: () => newFolderFormRef.current.submit()
        })
      }), /*#__PURE__*/react.createElement(BottomSheetContent, {
        itemType: itemType,
        itemId: itemId,
        api: api,
        closeCallback: () => setOpen(false),
        initialFocusRef: NewFolderTemplateFocusRef,
        ref: newFolderFormRef
      }));
    }

    return /*#__PURE__*/react.createElement(index_es/* BottomSheet */.R, index_esm_extends({}, sharedProps, {
      snapPoints: _ref => {
        var {
          maxHeight
        } = _ref;
        return [maxHeight, Math.max(maxHeight * 0.7, 510)];
      },
      header: /*#__PURE__*/react.createElement(BottomSheetToolbar$1, {
        onDismiss: () => setOpen(false)
      })
    }), /*#__PURE__*/react.createElement(BottomSheetContent$1, {
      initialFocusRef: FavoritesMoreOptionsFocusRef,
      itemType: itemType,
      itemId: itemId,
      api: api,
      closeCallback: () => setOpen(false),
      errorMessage: finalErrorMessage,
      foldersWithItem: foldersWithItem,
      items: items,
      setErrorMessage: setErrorMessage,
      toggleCreateNewFolder: toggleCreateNewFolder
    }));
  }

  return /*#__PURE__*/react.createElement(index_es/* BottomSheet */.R, sharedProps, /*#__PURE__*/react.createElement(LoginTemplate, {
    closeCallback: () => setOpen(false),
    redirectUrl: redirectUrl
  }));
};

var SaveAdModal = props => {
  var {
    itemType,
    itemId,
    api,
    setOpen,
    redirectUrl,
    restoreFocus,
    toggled,
    userId
  } = props;
  useStartEventTracking({
    toggled,
    userId,
    itemType,
    itemId
  });
  var [createNewFolder, setCreateNewFolder] = (0,react.useState)(false);
  var toggleCreateNewFolder = (0,react.useCallback)(() => setCreateNewFolder(createNewFolder => !createNewFolder), []);
  var [errorMessage, setErrorMessage] = (0,react.useState)('');
  var {
    items,
    errorMessage: fetchFoldersErrorMessage,
    foldersWithItem
  } = useFetchFolders({
    api,
    itemType,
    itemId,
    userId
  });
  var newFolderFormRef = (0,react.useRef)(null);
  var FavoritesMoreOptionsFocusRef = (0,react.useRef)(null);
  var NewFolderTemplateFocusRef = (0,react.useRef)(null);
  var closeCallback = (0,react.useCallback)(() => {
    setOpen(false);
    restoreFocus();
  }, [setOpen, restoreFocus]);
  var finalErrorMessage = errorMessage || fetchFoldersErrorMessage;
  var sharedProps = {
    className: classes.modal,
    isOpen: true,
    onDismiss: () => closeCallback()
  };

  if (userId) {
    if (createNewFolder) {
      return /*#__PURE__*/react.createElement(Modal, index_esm_extends({}, sharedProps, {
        key: "create-new-folder",
        max640: true,
        initialFocusRef: NewFolderTemplateFocusRef
      }), /*#__PURE__*/react.createElement(index_esm_ModalContent, {
        itemType: itemType,
        itemId: itemId,
        api: api,
        initialFocusRef: NewFolderTemplateFocusRef,
        closeCallback: closeCallback,
        ref: newFolderFormRef,
        onCancel: toggleCreateNewFolder,
        onSubmit: () => newFolderFormRef.current.submit()
      }));
    }

    return /*#__PURE__*/react.createElement(Modal, index_esm_extends({}, sharedProps, {
      key: "select-folder",
      max640: true,
      initialFocusRef: FavoritesMoreOptionsFocusRef
    }), /*#__PURE__*/react.createElement(ModalContent$1, {
      itemType: itemType,
      itemId: itemId,
      api: api,
      initialFocusRef: FavoritesMoreOptionsFocusRef,
      closeCallback: closeCallback,
      errorMessage: finalErrorMessage,
      foldersWithItem: foldersWithItem,
      items: items,
      setErrorMessage: setErrorMessage,
      toggleCreateNewFolder: toggleCreateNewFolder
    }));
  }

  return /*#__PURE__*/react.createElement(Modal, index_esm_extends({}, sharedProps, {
    key: "login"
  }), /*#__PURE__*/react.createElement(LoginTemplate, {
    closeCallback: closeCallback,
    redirectUrl: redirectUrl
  }));
};

var _excluded = ["redirectUrl"];
var instance;

function getApiInstance(p) {
  if (!instance) {
    instance = new FavoriteBrowserCache(p.userId, undefined, undefined, undefined, p.fetch, p.baseUri);
  }

  return instance;
}

function createComponent(_ref) {
  var {
    redirectUrl: _redirectUrl
  } = _ref,
      options = _objectWithoutProperties(_ref, _excluded);

  var api = getApiInstance(options);
  var {
    userId
  } = options;
  var SaveAd = /*#__PURE__*/(0,react.forwardRef)((props, forwardRef) => {
    var _props$christmasGiftL, _props$toggled, _props$isOpen;

    var {
      buttonClass,
      itemType,
      itemId,
      isMobile,
      redirectUrl = _redirectUrl,
      renderNumFavs,
      variant,
      christmasGiftList = (_props$christmasGiftL = props.christmasGiftList) !== null && _props$christmasGiftL !== void 0 ? _props$christmasGiftL : false
    } = props;
    var [toggled, setToggled] = (0,react.useState)((_props$toggled = props.toggled) !== null && _props$toggled !== void 0 ? _props$toggled : false);
    var [isOpen, setOpen] = (0,react.useState)((_props$isOpen = props.isOpen) !== null && _props$isOpen !== void 0 ? _props$isOpen : false);
    var [numFavs, setNumFavs] = (0,react.useState)(0);
    var restoreFocusRef = (0,react.useRef)(null); // Handle the case of an invalid itemId

    if (false) {}

    (0,react.useEffect)(() => {
      if (userId) {
        var cleanup = api.getFavoriteState(itemType, itemId, toggled => setToggled(toggled));

        if (cleanup) {
          return () => cleanup();
        }
      }
    }, [itemType, itemId]);
    (0,react.useEffect)(() => {
      if (renderNumFavs) {
        var cleanup = api.subscribeToRecount(itemType, itemId, setNumFavs);

        if (cleanup) {
          return () => cleanup();
        }
      }
    }, [itemType, itemId, renderNumFavs]); // Focus is only restored by the Modal/BottomSheet if an element already had focus before opening
    // On Safari in particular buttons won't receive focus when clicking on them.

    var restoreFocus = (0,react.useCallback)(() => {
      setTimeout(() => {
        if (restoreFocusRef.current && document.activeElement !== restoreFocusRef.current) {
          // The scrolling behavior when calling .focus() is very unreliable and incosistent between browsers
          // The call below will ensure a consistent and satisfactory UX by scrolling things into view ahead of calling .focus()
          es(restoreFocusRef.current, {
            block: 'center',
            inline: 'center',
            scrollMode: 'if-needed'
          });
          restoreFocusRef.current.focus();
        }
      }, 0);
    }, []);
    var sharedProps = {
      itemType,
      itemId,
      api,
      isOpen,
      setOpen,
      redirectUrl,
      restoreFocus,
      toggled,
      userId
    };
    return /*#__PURE__*/react.createElement(Provider, {
      value: christmasGiftList
    }, /*#__PURE__*/react.createElement(HeartButton, {
      className: buttonClass,
      numFavs: numFavs,
      onClick: () => setOpen(true),
      ref: element => {
        restoreFocusRef.current = element;

        if (forwardRef) {
          if (typeof forwardRef === 'function') {
            forwardRef(element);
          } else {
            forwardRef.current = element;
          }
        }
      },
      toggled: toggled,
      variant: variant
    }), isOpen && (isMobile ? /*#__PURE__*/react.createElement(SaveAdBottomSheet, sharedProps) : /*#__PURE__*/react.createElement(SaveAdModal, sharedProps)));
  });
  return SaveAd;
}


//# sourceMappingURL=index.esm.js.map


/***/ }),

/***/ 5105:
/***/ (function(__unused_webpack_module, exports) {

!function(t,e){ true?e(exports):0}(this,function(t){"use strict";var i="pulse";function a(){window[i]=window[i]||function(){for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];(window[i].q=window[i].q||[]).push(e)},window[i].q=window[i].q||[];for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];window[i].q.push(e)}function e(i,o){var t,e,n;g(i),"UIElement"!==(null===(e=(t=i).object)||void 0===e?void 0:e.type)&&"RecommendationList"!==(null===(n=t.object)||void 0===n?void 0:n.type)&&"ListingItem"!==(null===(n=t.object)||void 0===n?void 0:n.type)&&"RecommendationItem"!==(null===(t=t.object)||void 0===t?void 0:t.type)||null!=o&&o.disableAddPageContext?l("trackerEvent",i,o):a("pageStateTracker",function(t){t.evaluateEventInputs().then(function(t){var e,n;i.object&&(i.object.page={id:null===(n=t.object)||void 0===n?void 0:n.id,type:null===(n=t.object)||void 0===n?void 0:n.type,url:null===(n=t.object)||void 0===n?void 0:n.url}),null!==(n=i.vertical)&&void 0!==n&&n.name||null===(e=t.vertical)||void 0===e||!e.name||(i.vertical=t.vertical),i.pageViewId=t.pageViewId,l("trackerEvent",i,o)})})}function n(){var t=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{},e=1<arguments.length?arguments[1]:void 0;g(t),t.pageViewId=function(){var t=window.crypto.getRandomValues(new Uint8Array(16));t[6]=15&t[6]|64,t[8]=191&t[8]|128;var e="";return e+=t[0].toString(16),e+=t[1].toString(16),e+=t[2].toString(16),e+=t[3].toString(16),e+="-",e+=t[4].toString(16),e+=t[5].toString(16),e+="-",e+=t[6].toString(16),e+=t[7].toString(16),e+="-",e+=t[8].toString(16),e+=t[9].toString(16),e+="-",e+=t[10].toString(16),e+=t[11].toString(16),e+=t[12].toString(16),e+=t[13].toString(16),e+=t[14].toString(16),e+=t[15].toString(16)}(),t.type="View",a("pageStateTracker.track","trackerEvent",t,e),a("update",{pageViewId:t.pageViewId},!0),a("pageStateTracker.update",t,!1)}function o(t){g(t),a("update",t,!0),a("pageStateTracker.update",t,!0)}function r(e){a("pageStateTracker",function(t){t.evaluateEventInputs().then(function(t){e(t)})})}function c(t){a(t)}function d(t){a("pageStateTracker",t)}function l(t,e,n){a("track",t,1<arguments.length&&void 0!==e?e:{},2<arguments.length?n:void 0)}function g(t){t.vertical&&(t.vertical["@type"]="MarketplaceVertical")}t.default={trackEvent:e,trackPageView:n,setState:o,getPageState:r,getTracker:c,getPageStateTracker:d},t.getPageState=r,t.getPageStateTracker=d,t.getTracker=c,t.setState=o,t.trackEvent=e,t.trackPageView=n,Object.defineProperty(t,"__esModule",{value:!0})});
//# sourceMappingURL=client.min.js.map


/***/ }),

/***/ 2985:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 9067:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 3769:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 2407:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 3285:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ })

}]);